import { templates } from './templates-map.js';

const originalGetItem = window.originalGetItem || Storage.prototype.getItem;
const _getAppSecret = () => window._getAppSecret();

// Inject invoice-template into the DOM so that child iframes can fetch it
function injectInvoiceTemplate() {
    if (templates['invoice-template'] && !document.getElementById('invoice-template')) {
        const script = document.createElement('script');
        script.type = 'text/html';
        script.id = 'invoice-template';
        script.textContent = templates['invoice-template'];
        document.body.appendChild(script);
    }
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectInvoiceTemplate);
} else {
    injectInvoiceTemplate();
}

// Immediately apply Navigation Animation state from localStorage on load
        try {
            if (localStorage.getItem('nav_anim_enabled') === 'false') {
                document.documentElement.classList.add('no-animations');
            }
        } catch (e) { }

        // Listen for changes to nav_anim_enabled to dynamically update animations
        const syncNavAnim = (val) => {
            if (val === 'false') {
                document.documentElement.classList.add('no-animations');
            } else {
                document.documentElement.classList.remove('no-animations');
            }
        };

        window.addEventListener('storage', (e) => {
            if (e.key === 'nav_anim_enabled' || e.key === 'mobile_nav_anim_enabled') {
                syncNavAnim(e.newValue);
            }
        });

        window.addEventListener('safeStorageChange', (e) => {
            if (e.detail && e.detail.key === 'nav_anim_enabled') {
                const val = e.detail.val !== undefined ? e.detail.val : e.detail.newValue;
                syncNavAnim(val);
            }
        });

        /* --- SESSION PROTOCOL PARENT MANAGER --- */
        window.SessionProtocolParent = {
            storageKey: 'session_protocol_enabled',
            callbacks: [],

            isEnabled: function () {
                try {
                    // Temporarily deactivate session protocol for login and subscription views or modals
                    const loginEl = document.getElementById('view-login');
                    const subEl = document.getElementById('view-subscription');
                    const loginModal = document.getElementById('premium-login-modal');
                    const unlockModal = document.getElementById('premium-unlock-modal');

                    const isViewActive = (
                        (loginEl && loginEl.classList.contains('active') && loginEl.style.display !== 'none') ||
                        (subEl && subEl.classList.contains('active') && subEl.style.display !== 'none')
                    );

                    const isModalActive = (
                        (loginModal && loginModal.style.display !== 'none') ||
                        (unlockModal && unlockModal.style.display !== 'none')
                    );

                    let currentView = '';
                    if (typeof window.safeStorage !== 'undefined') {
                        currentView = window.safeStorage.getItem('current_suite_view') || '';
                    } else {
                        currentView = localStorage.getItem('current_suite_view') || '';
                    }
                    const cv = currentView.toLowerCase();
                    const isMatchingView = (
                        cv === 'login' || cv === 'login.html' ||
                        cv === 'subscription' || cv === 'plan and upgrade.html' || cv === 'subscription-mobile.html' || cv === '#pro-tier'
                    );

                    if (isViewActive || isModalActive || isMatchingView) {
                        return false;
                    }
                } catch (e) { }

                try {
                    let storedVal = localStorage.getItem(this.storageKey);
                    if (storedVal === null) {
                        storedVal = 'false';
                        localStorage.setItem(this.storageKey, 'false');
                    }
                    return storedVal === 'true';
                } catch (e) {
                    return false;
                }
            },

            setEnabled: function (val) {
                try {
                    const strVal = val ? 'true' : 'false';
                    if (window.safeStorage) {
                        window.safeStorage.setItem(this.storageKey, strVal);
                    } else {
                        localStorage.setItem(this.storageKey, strVal);
                        window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: this.storageKey, val: strVal } }));
                    }
                    this.notifyChange(val);
                } catch (e) { }
            },

            registerCallback: function (cb) {
                if (typeof cb === 'function') {
                    this.callbacks.push(cb);
                    cb(this.isEnabled());
                }
            },

            notifyChange: function (val) {
                this.callbacks.forEach(cb => {
                    try { cb(val); } catch (e) { }
                });
            },

            showOverlay: function () {
                const overlay = document.getElementById('session-pause-overlay');
                if (overlay) {
                    overlay.style.display = 'flex';
                }
            },

            hideOverlay: function () {
                const overlay = document.getElementById('session-pause-overlay');
                if (overlay) {
                    overlay.style.display = 'none';
                }
                document.body.classList.remove('is-blurred');
            },

            init: function () {
                if (this.isEnabled()) {
                    document.body.classList.remove('is-blurred');
                }

                document.addEventListener('visibilitychange', () => {
                    const isVisible = document.visibilityState === 'visible';
                    const active = this.isEnabled();

                    if (isVisible) {
                        document.body.classList.remove('is-blurred');
                        if (active) {
                            this.showOverlay();
                        }
                    } else {
                        if (active) {
                            document.body.classList.add('is-blurred');
                        }
                    }
                });

                window.addEventListener('storage', (e) => {
                    if (e.key === this.storageKey || e.key === 'mobile_' + this.storageKey) {
                        const active = e.newValue === 'true';
                        this.notifyChange(active);
                        if (!active) {
                            this.hideOverlay();
                        }
                    }
                });
            }
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => window.SessionProtocolParent.init());
        } else {
            window.SessionProtocolParent.init();
        }

        // --- GLOBAL SUITE SOUNDS MANAGER ---
        (function () {
            const SOUNDS = {
                DOWNLOAD_SUCCESS: '/assets/QR_AND_BARCODE_DOWNLAOD_SUCCESS_kz44ak.mp3',
                POP_UP: '/assets/POP_UP_PANEL_TOADT_NOTIFICATION_uszv7n.mp3',
                ERROR: '/assets/error_ru5uo5.mp3',
                UPGRADE: '/assets/UPGARDE_SUCCEESFUL_a99k7z.mp3',
                TRASH: '/assets/Mac_Trash_Delete_Apple_Sound_-_Sound_Effect_Free_-_Sound_Central_ylygst.mp3',
                DECODE_SUCCESS: '/assets/DECODE_BEEP.mp3',
                CLICK_1: '/assets/clcik_jmdsgk.mp3',
                CLICK_2: '/assets/clcik_2_kzrp4w.mp3',
                BEST_EVER: '/assets/best_ever_glmbh7.mp3',
                BOTTOM_NAV: '/assets/bottom_nav_2_aegk0l.mp3',
                LOCK_SUCCESS: '/assets/Fade_In_MIUI_10_Stock_Notification-635177-mobiles24_1_zwpj5o.mp3'
            };

            const audioCache = {};
            let audioCtx = null;
            const lastPlayTimes = {};

            const SythEngine = {
                init: function () {
                    if (!audioCtx) {
                        audioCtx = new (window.AudioContext || window.webkitAudioContext)();
                    }
                    if (audioCtx.state === 'suspended') {
                        audioCtx.resume();
                    }
                },
                play: function (profile, volume) {
                    try {
                        this.init();
                        const now = audioCtx.currentTime;
                        const gain = audioCtx.createGain();
                        gain.gain.setValueAtTime(0, now);

                        if (profile === 'TYPING_CLICKY' || profile === 'TYPING_MECHANICAL') {
                            const buffer = audioCtx.createBuffer(1, audioCtx.sampleRate * 0.05, audioCtx.sampleRate);
                            const data = buffer.getChannelData(0);
                            for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;

                            const source = audioCtx.createBufferSource();
                            source.buffer = buffer;
                            const filter = audioCtx.createBiquadFilter();
                            filter.type = 'bandpass';
                            filter.frequency.value = 2500;
                            filter.Q.value = 8;

                            gain.gain.linearRampToValueAtTime(0.4 * volume, now + 0.002);
                            gain.gain.exponentialRampToValueAtTime(0.01, now + 0.04);

                            source.connect(filter);
                            filter.connect(gain);
                            gain.connect(audioCtx.destination);
                            source.start(now);
                            source.stop(now + 0.04);
                        } else if (profile === 'TYPING_CLASSIC' || profile === 'TYPING_TYPEWRITER') {
                            const osc = audioCtx.createOscillator();
                            osc.type = 'triangle';
                            osc.frequency.setValueAtTime(1200, now);
                            osc.frequency.exponentialRampToValueAtTime(100, now + 0.1);

                            gain.gain.linearRampToValueAtTime(0.5 * volume, now + 0.005);
                            gain.gain.exponentialRampToValueAtTime(0.01, now + 0.1);

                            osc.connect(gain);
                            gain.connect(audioCtx.destination);
                            osc.start(now);
                            osc.stop(now + 0.1);
                        } else if (profile === 'TYPING_SYSTEM_CLICK') {
                            const osc = audioCtx.createOscillator();
                            osc.type = 'sine';
                            osc.frequency.setValueAtTime(1400, now);
                            osc.frequency.exponentialRampToValueAtTime(800, now + 0.05);

                            gain.gain.linearRampToValueAtTime(0.2 * volume, now + 0.002);
                            gain.gain.exponentialRampToValueAtTime(0.01, now + 0.05);

                            osc.connect(gain);
                            gain.connect(audioCtx.destination);
                            osc.start(now);
                            osc.stop(now + 0.05);
                        } else {
                            const osc = audioCtx.createOscillator();
                            osc.type = 'sine';
                            osc.frequency.setValueAtTime(440, now);
                            osc.frequency.exponentialRampToValueAtTime(100, now + 0.02);

                            gain.gain.linearRampToValueAtTime(0.3 * volume, now + 0.001);
                            gain.gain.exponentialRampToValueAtTime(0.01, now + 0.02);

                            osc.connect(gain);
                            gain.connect(audioCtx.destination);
                            osc.start(now);
                            osc.stop(now + 0.02);
                        }
                    } catch (e) {
                        console.warn("Synth play error", e);
                    }
                }
            };

            let volume = parseFloat(localStorage.getItem('suite_sound_volume') || '0.7');
            let muted = localStorage.getItem('suite_sound_muted') === 'true';
            let typingEnabled = localStorage.getItem('suite_typing_enabled') !== 'false';
            let typingVolume = parseFloat(localStorage.getItem('suite_typing_volume') || '0.5');
            let typingTune = localStorage.getItem('suite_typing_tune') || 'TYPING_MECHANICAL';
            let bottomNavEnabled = localStorage.getItem('suite_bottom_nav_enabled') !== 'false';
            let bottomNavVolume = parseFloat(localStorage.getItem('suite_bottom_nav_volume') || '0.5');

            window.SuiteSounds = {
                get muted() { return muted; },
                get volume() { return volume; },
                get typingEnabled() { return typingEnabled; },
                get typingVolume() { return typingVolume; },
                get typingTune() { return typingTune; },
                get bottomNavEnabled() { return bottomNavEnabled; },
                get bottomNavVolume() { return bottomNavVolume; },

                setMuted: function (val) {
                    muted = !!val;
                    safeStorage.setItem('suite_sound_muted', muted);
                },
                setVolume: function (val) {
                    volume = Math.max(0, Math.min(1, parseFloat(val)));
                    safeStorage.setItem('suite_sound_volume', volume);
                },
                setTypingEnabled: function (val) {
                    typingEnabled = !!val;
                    safeStorage.setItem('suite_typing_enabled', typingEnabled);
                },
                setTypingVolume: function (val) {
                    typingVolume = Math.max(0, Math.min(1, parseFloat(val)));
                    safeStorage.setItem('suite_typing_volume', typingVolume);
                },
                setTypingTune: function (tune) {
                    typingTune = tune;
                    safeStorage.setItem('suite_typing_tune', typingTune);
                },
                setBottomNavEnabled: function (val) {
                    bottomNavEnabled = !!val;
                    safeStorage.setItem('suite_bottom_nav_enabled', bottomNavEnabled);
                },
                setBottomNavVolume: function (val) {
                    bottomNavVolume = Math.max(0, Math.min(1, parseFloat(val)));
                    safeStorage.setItem('suite_bottom_nav_volume', bottomNavVolume);
                },

                play: function (key, isTyping = false) {
                    try {
                        if (muted) return;
                        if (isTyping && !typingEnabled) return;
                        if (key === 'BOTTOM_NAV' && !bottomNavEnabled) return;

                        const now = Date.now();
                        if (lastPlayTimes[key] && (now - lastPlayTimes[key] < 150)) {
                            return;
                        }
                        lastPlayTimes[key] = now;

                        if (key.startsWith('TYPING_')) {
                            SythEngine.play(key, typingVolume);
                        } else if (SOUNDS[key]) {
                            if (!audioCache[key]) {
                                const audio = new Audio();
                                audio.crossOrigin = 'anonymous';
                                audio.src = SOUNDS[key];
                                audioCache[key] = audio;
                            }
                            const audio = audioCache[key];
                            audio.volume = key === 'BOTTOM_NAV' ? (bottomNavVolume * volume) : volume;
                            audio.currentTime = 0;
                            audio.play().catch(() => { });
                        }
                    } catch (err) { }
                }
            };

            window.addEventListener('message', async (event) => {
                if (!event.data) return;
                if (event.data.type === 'SUITE_SOUND_TRIGGER') {
                    let key = event.data.key;
                    if (key === 'TYPING' && window.SuiteSounds) {
                        key = window.SuiteSounds.typingTune;
                    }
                    window.SuiteSounds.play(key, event.data.isTyping || false);
                } else if (event.data.type === 'login-success') {
                    if (event.data.user) {
                        localStorage.setItem('userStoreEnc', event.data.user);
                        try {
                            const bytes = CryptoJS.AES.decrypt(event.data.user, _getAppSecret());
                            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                            window.userData = decryptedData;
                            if (window.suiteAuthBridge && window.suiteAuthBridge.updateProfile) {
                                window.suiteAuthBridge.updateProfile(decryptedData);
                            }
                        } catch (err) {
                            console.error("Error decrypting user data:", err);
                        }
                    }
                    if (typeof updateTelemetryStats === 'function') updateTelemetryStats();
                    if (typeof loadDensityStats === 'function') loadDensityStats();

                    // Seamless Unlock Logic (User authenticated successfully: Set session to unlocked)
                    if (window._0x83e2) {
                        window._0x83e2._0x2k8f = true;
                        const lockScreen = document.getElementById('app-lock-screen');
                        if (lockScreen) lockScreen.style.display = 'none';
                    }

                    // Move to landing page ONLY on registration, otherwise show the profile panel directly
                    if (event.data.fromSubscription) {
                        // Do not switch view to login/profile panel, just let subscription modal close and proceed
                    } else if (event.data.isRegistration) {
                        setTimeout(() => {
                            if (typeof closeSPA === 'function') closeSPA();
                        }, 1200);
                    } else {
                        if (typeof switchView === 'function') {
                            switchView('login');
                        }
                    }
                } else if (event.data.type === 'logout') {
                    console.log("Logout received from iframe");
                    localStorage.setItem('explicit_logout', 'true');
                    localStorage.removeItem('userStoreEnc');
                    window.userData = null;
                    if (window.suiteAuthBridge && typeof window.suiteAuthBridge.logout === 'function') {
                        await window.suiteAuthBridge.logout();
                    }
                    // Reset login frame
                    const loginFrame = document.getElementById('login-frame');
                    if (loginFrame) loginFrame.srcdoc = "";

                    // Move to landing page
                    if (typeof closeSPA === 'function') {
                        closeSPA();
                    } else {
                        window.location.reload();
                    }
                }
            });

            document.addEventListener('mousedown', () => SythEngine.init(), { once: true });
            document.addEventListener('touchstart', () => SythEngine.init(), { once: true });

            window.addEventListener('safeStorageChange', (e) => {
                if (!e.detail || !e.detail.key) return;
                const { key, val } = e.detail;
                if (key === 'suite_sound_muted') muted = (val === 'true' || val === true);
                if (key === 'suite_sound_volume') volume = parseFloat(val);
                if (key === 'suite_typing_enabled') typingEnabled = (val === 'true' || val === true);
                if (key === 'suite_typing_volume') typingVolume = parseFloat(val);
                if (key === 'suite_typing_tune') typingTune = val;
                if (key === 'suite_bottom_nav_enabled') bottomNavEnabled = (val === 'true' || val === true);
                if (key === 'suite_bottom_nav_volume') bottomNavVolume = parseFloat(val);
                if (typeof updateAudioSettingsUI === 'function') updateAudioSettingsUI();
            });
        })();

        window.triggerSound = function (key) {
            if (window.SuiteSounds && typeof window.SuiteSounds.play === 'function') {
                window.SuiteSounds.play(key);
            }
        };

        window.isFullscreenPending = false;

        window.triggerFullscreen = function (targetElement) {
            if (window.isFullscreenPending) return;

            const el = targetElement || document.documentElement;
            const targetDoc = el.ownerDocument || document;

            const isFullscreen = targetDoc.fullscreenElement ||
                targetDoc.webkitFullscreenElement ||
                targetDoc.mozFullScreenElement ||
                targetDoc.msFullscreenElement ||
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                (window.parent && window.parent.document && (
                    window.parent.document.fullscreenElement ||
                    window.parent.document.webkitFullscreenElement
                )) ||
                (window.top && window.top.document && (
                    window.top.document.fullscreenElement ||
                    window.top.document.webkitFullscreenElement
                ));
            if (!isFullscreen) {
                const req = el.requestFullscreen ||
                    el.webkitRequestFullscreen ||
                    el.mozRequestFullScreen ||
                    el.msRequestFullscreen;
                if (req) {
                    window.isFullscreenPending = true;
                    req.call(el).then(() => {
                        window.isFullscreenPending = false;
                    }).catch(err => {
                        console.warn("Local element fullscreen failed, trying fallback...", err);
                        // Fallback to parent document
                        if (window.parent && window.parent.document && el !== window.parent.document.documentElement) {
                            const pDocEl = window.parent.document.documentElement;
                            const pReq = pDocEl.requestFullscreen || pDocEl.webkitRequestFullscreen;
                            if (pReq) {
                                pReq.call(pDocEl).then(() => {
                                    window.isFullscreenPending = false;
                                }).catch(() => {
                                    window.isFullscreenPending = false;
                                });
                            } else {
                                window.isFullscreenPending = false;
                            }
                        } else {
                            window.isFullscreenPending = false;
                        }
                    });
                }
            }
        };

        window.handleGlobalFullscreenTrigger = function (e) {
            const storage = window.safeStorage || window.localStorage;
            const isEnabled = storage ? (storage.getItem('fullscreen_on_click') === 'true') : false;
            if (!isEnabled) return;

            if (e && e.target) {
                const target = e.target;
                if (target.closest && (
                    target.closest('input[type="file"]') ||
                    target.closest('#fullscreen-toggle-btn') ||
                    target.closest('#mobile-sidebar-toggle') ||
                    target.closest('#main-sidebar')
                )) {
                    return;
                }
                const doc = target.ownerDocument || document;
                window.triggerFullscreen(doc.documentElement);
            } else {
                window.triggerFullscreen(document.documentElement);
            }
        };

        document.addEventListener('click', (e) => {
            if (typeof window.handleGlobalFullscreenTrigger === 'function') {
                window.handleGlobalFullscreenTrigger(e);
            }
        }, { capture: true });

        document.addEventListener('touchstart', (e) => {
            if (typeof window.handleGlobalFullscreenTrigger === 'function') {
                window.handleGlobalFullscreenTrigger(e);
            }
        }, { capture: true, passive: true });

        const lenis = new Lenis({
            wrapper: document.getElementById('main-scroller'),
            content: document.querySelector('.app-container'),
            autoRaf: true,
        });

        lenis.on('scroll', (e) => {
            const winScroll = e.animatedScroll;
            const height = e.limit;
            const scrolled = height > 0 ? Math.min(Math.max(winScroll / height, 0), 1) : 0;

            document.getElementById("scroll-progress-top").style.transform = `scaleX(${scrolled})`;
        });

        const scroller = document.getElementById('main-scroller');

        const observerOptions = {
            root: document.getElementById('main-scroller'),
            threshold: 0.1
        };

        const activeTimeouts = new Map();

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('active');
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);

        document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

        function animateOutHome(callback) {
            const homeView = document.getElementById('view-home');
            if (homeView && homeView.classList.contains('active')) {
                const reveals = homeView.querySelectorAll('.reveal');
                reveals.forEach(rev => {
                    rev.classList.remove('active');
                    rev.classList.add('exit-active');
                });
                setTimeout(() => {
                    reveals.forEach(rev => {
                        rev.classList.remove('exit-active');
                    });
                    callback();
                }, 600);
            } else {
                callback();
            }
        }

        function initAnimations() {
            setTimeout(() => {
                document.body.classList.add('loaded');
                showToast();
            }, 150);
        }

        function showToast(msg, isError = false, duration = 3000) {
            const toast = document.getElementById('toast');
            if (toast) {
                const titleEl = toast.querySelector('.toast-title');
                const descEl = toast.querySelector('.toast-desc');
                const iconContainer = toast.querySelector('.toast-icon');

                // Determine if we should use the premium App Lock dark mode styling
                const isLockScreenActive = document.getElementById('app-lock-screen') &&
                    document.getElementById('app-lock-screen').style.display === 'flex';
                const isAuthModalActive = document.getElementById('app-auth-modal') &&
                    document.getElementById('app-auth-modal').style.display === 'flex';

                const useDarkSecurityTheme = isError || isLockScreenActive || isAuthModalActive;

                if (msg) {
                    if (titleEl) titleEl.innerText = isError ? "Security Alert" : "System Notification";
                    if (descEl) descEl.innerText = msg;

                    if (useDarkSecurityTheme) {
                        if (isError) {
                            // Premium Glassmorphic Red Warning Style (Distinct from dark panel)
                            toast.style.background = 'linear-gradient(135deg, rgba(141, 10, 36, 0.95), rgba(76, 5, 25, 0.98))';
                            toast.style.borderColor = 'rgba(244, 63, 94, 0.5)';
                            toast.style.boxShadow = '0 15px 40px rgba(244, 63, 94, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.15)';
                            toast.style.color = '#ffffff';
                            if (titleEl) {
                                titleEl.style.color = '#ffe4e6';
                                titleEl.innerText = "SECURITY ALERT";
                            }
                            if (descEl) descEl.style.color = 'rgba(255, 255, 255, 0.85)';
                            if (iconContainer) {
                                iconContainer.style.background = 'rgba(244, 63, 94, 0.2)';
                                iconContainer.style.boxShadow = 'none';
                                iconContainer.innerHTML = '<span class="material-symbols-outlined" style="color: #fda4af; font-size: 20px;">gpp_bad</span>';
                            }
                        } else {
                            // Premium Glassmorphic Green Success Style (Distinct from dark panel)
                            toast.style.background = 'linear-gradient(135deg, rgba(6, 95, 70, 0.95), rgba(4, 78, 64, 0.98))';
                            toast.style.borderColor = 'rgba(52, 211, 153, 0.5)';
                            toast.style.boxShadow = '0 15px 40px rgba(16, 185, 129, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.15)';
                            toast.style.color = '#ffffff';
                            if (titleEl) {
                                titleEl.style.color = '#d1fae5';
                                titleEl.innerText = "ACCESS CONTROL";
                            }
                            if (descEl) descEl.style.color = 'rgba(255, 255, 255, 0.85)';
                            if (iconContainer) {
                                iconContainer.style.background = 'rgba(52, 211, 153, 0.2)';
                                iconContainer.style.boxShadow = 'none';
                                iconContainer.innerHTML = '<span class="material-symbols-outlined" style="color: #a7f3d0; font-size: 20px;">verified_user</span>';
                            }
                        }
                    } else {
                        // Standard Light Style
                        toast.style.borderColor = '';
                        toast.style.background = '';
                        toast.style.boxShadow = '';
                        toast.style.color = '';
                        if (titleEl) titleEl.style.color = '';
                        if (descEl) descEl.style.color = '';
                        if (iconContainer) {
                            iconContainer.style.background = '';
                            iconContainer.style.boxShadow = '';
                            iconContainer.innerHTML = '<i data-lucide="sparkles" style="color: #70e000;"></i>';
                            if (window.lucide) window.lucide.createIcons();
                        }
                    }
                } else {
                    // Default values if called without message (e.g. startup toast)
                    toast.style.borderColor = '';
                    toast.style.background = '';
                    toast.style.boxShadow = '';
                    toast.style.color = '';
                    if (titleEl) {
                        titleEl.style.color = '';
                        titleEl.innerText = "Ecosystem Initialized";
                    }
                    if (descEl) {
                        descEl.style.color = '';
                        descEl.innerText = "Premium console ready for physical navigation";
                    }
                    if (iconContainer) {
                        iconContainer.style.background = '';
                        iconContainer.style.boxShadow = '';
                        iconContainer.innerHTML = '<i data-lucide="sparkles"></i>';
                        if (window.lucide) window.lucide.createIcons();
                    }
                }

                toast.classList.add('show');

                if (toast.dismissTimer) clearTimeout(toast.dismissTimer);
                toast.dismissTimer = setTimeout(() => {
                    toast.classList.remove('show');
                }, duration);

                if (!toast.hasClickListener) {
                    toast.addEventListener('click', () => {
                        clearTimeout(toast.dismissTimer);
                        toast.classList.remove('show');
                    });
                    toast.hasClickListener = true;
                }
            }
        }

        if (document.readyState === 'complete') {
            initAnimations();
        } else {
            window.addEventListener('load', initAnimations);
        }

        document.querySelectorAll('.matrix-card').forEach(card => {
            card.addEventListener('click', function (e) {
                e.preventDefault();
                const targetUrl = this.getAttribute('href');

                const sibling = Array.from(this.parentElement.children).find(el => el !== this && el.classList.contains('matrix-card'));
                if (sibling) {
                    sibling.classList.add('card-dimmed');
                }

                this.classList.add('card-flipping');

                // Animate out features panel immediately during card flip
                const featuresPanel = document.querySelector('.features-panel');
                if (featuresPanel) {
                    featuresPanel.classList.remove('active');
                    featuresPanel.classList.add('exit-active');
                }

                let navigated = false;
                const navigate = () => {
                    if (navigated) return;
                    navigated = true;
                    if (featuresPanel) {
                        featuresPanel.classList.remove('exit-active');
                    }
                    if (!switchView(targetUrl)) {
                        window.location.href = targetUrl;
                    }
                    setTimeout(() => {
                        this.classList.remove('card-flipping');
                        if (sibling) sibling.classList.remove('card-dimmed');
                    }, 400);
                };

                this.addEventListener('animationend', navigate, { once: true });
                setTimeout(navigate, 320);
            });
        });

        const navCenter = document.querySelector('.nav-center');
        const actionModal = document.getElementById('action-modal');
        const modalClose = document.getElementById('modal-close');
        let isClosingActionModal = false;

        function openActionConsole() {
            if (!actionModal) return;
            if (!actionModal.classList.contains('active')) {
                actionModal.classList.add('active');
                history.pushState({ modalOpen: true }, '', '');
            }
        }

        function closeActionConsole(fromPopState = false) {
            if (!actionModal) return;
            actionModal.classList.remove('active');
            if (!fromPopState && history.state && history.state.modalOpen) {
                isClosingActionModal = true;
                history.back();
                setTimeout(() => { isClosingActionModal = false; }, 350);
            }
        }

        window.openActionConsole = openActionConsole;
        window.closeActionConsole = closeActionConsole;

        if (navCenter) {
            navCenter.addEventListener('click', function () {
                navCenter.classList.add('clicked');
                openActionConsole();
            });

            navCenter.addEventListener('animationend', (e) => {
                if (e.animationName === 'nav-pop') {
                    navCenter.classList.remove('clicked');
                }
            });
        }

        if (actionModal) {
            if (modalClose) {
                modalClose.addEventListener('click', function (e) {
                    e.stopPropagation();
                    closeActionConsole();
                });
            }

            actionModal.addEventListener('click', function (e) {
                if (e.target === actionModal) {
                    closeActionConsole();
                }
            });
        }

        window.showPremiumUnlockModal = function (requiredPlan, featureName, descriptionText) {
            if (window.SessionProtocolParent) {
                window.SessionProtocolParent.hideOverlay();
            }
            // Check if user is logged in
            const user = (window.suiteAuth && window.suiteAuth.currentUser) || (window.auth && window.auth.currentUser);
            if (!user) {
                let hasPlanRecorded = false;
                try {
                    const historyStr = originalGetItem.call(localStorage, 'qr_bloom_purchase_history');
                    if (historyStr) {
                        const history = JSON.parse(historyStr);
                        if (Array.isArray(history) && history.length > 0) {
                            const activeItem = history.find(item => item.planName && item.planName !== 'Foundation' && item.planName !== 'normal' && new Date(item.expiryDate) > new Date());
                            if (activeItem) hasPlanRecorded = true;
                        }
                    }
                } catch (e) { }

                if (!hasPlanRecorded) {
                    try {
                        const enc = originalGetItem.call(localStorage, 'qrbloom_sub_enc');
                        if (enc) {
                            const b = CryptoJS.AES.decrypt(enc, _getAppSecret());
                            const obj = JSON.parse(b.toString(CryptoJS.enc.Utf8));
                            const now = Date.now();
                            const exMs = obj.expiresAtMs || 0;
                            const isActive = (obj.plan === 'foundation' || obj.plan === 'normal') ? false : (exMs > now && obj.status === 'active');
                            if (isActive) hasPlanRecorded = true;
                        }
                    } catch (e) { }
                }



                if (hasPlanRecorded) {
                    window.openPremiumLoginModal(descriptionText);
                    return;
                }
            }

            const modal = document.getElementById('premium-unlock-modal');
            if (!modal) return;

            const titleEl = document.getElementById('premium-unlock-title');
            const descEl = document.getElementById('premium-unlock-desc');
            const upgradeBtn = document.getElementById('premium-upgrade-btn');
            const badgeEl = document.getElementById('premium-unlock-badge');

            if (upgradeBtn) {
                if (requiredPlan === 'LIMIT_EXCEEDED_ULTRA') {
                    upgradeBtn.style.display = 'none';
                } else {
                    upgradeBtn.style.display = 'block';
                }
            }

            if (titleEl) {
                if (requiredPlan === 'LIMIT_EXCEEDED_ULTRA') {
                    titleEl.innerText = `LIMIT EXCEEDED`;
                    titleEl.style.background = 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)';
                } else if (requiredPlan === 'LIMIT_EXCEEDED_QUANTUM') {
                    titleEl.innerText = `LIMIT EXCEEDED`;
                    titleEl.style.background = 'linear-gradient(135deg, #c084fc 0%, #a855f7 100%)';
                } else {
                    titleEl.innerText = `${requiredPlan} REQUIRED`;
                    if (requiredPlan.toUpperCase() === 'VELOCITY') {
                        titleEl.style.background = 'linear-gradient(135deg, #fbbf24 0%, #d97706 100%)';
                    } else {
                        titleEl.style.background = 'linear-gradient(135deg, #c084fc 0%, #a855f7 100%)';
                    }
                }
                titleEl.style.webkitBackgroundClip = 'text';
                titleEl.style.webkitTextFillColor = 'transparent';
            }

            if (badgeEl) {
                if (requiredPlan.startsWith('LIMIT_EXCEEDED')) {
                    badgeEl.innerText = `Usage Limit Reached`;
                } else {
                    badgeEl.innerText = `Premium Plan Required`;
                }
            }

            if (descEl) {
                descEl.innerText = descriptionText;
            }

            modal.style.display = 'flex';

            // Push history state to intercept Android back button
            if (window.history && window.history.pushState) {
                window.history.pushState({ modalId: 'premium-unlock', premiumModalOpen: true }, "");
            }
        };

        window.closePremiumUnlockModal = function (fromPopState = false) {
            const modal = document.getElementById('premium-unlock-modal');
            if (modal) modal.style.display = 'none';

            // Restore landing page panels if user remains on the active home screen
            const homeView = document.getElementById('view-home');
            if (homeView && homeView.classList.contains('active')) {
                const reveals = homeView.querySelectorAll('.reveal');
                reveals.forEach(rev => {
                    rev.classList.remove('exit-active');
                    rev.classList.remove('active');
                    void rev.offsetWidth; // Force reflow
                    rev.classList.add('active');
                });
            }

            // Pop history state if closed manually (not via popstate)
            if (!fromPopState) {
                if (window.history && window.history.state && window.history.state.modalId === 'premium-unlock') {
                    window.history.back();
                }
            }
        };

        window.upgradePremiumAction = function () {
            window.closePremiumUnlockModal(true);
            if (typeof switchView === 'function') {
                switchView('subscription');
            }
        };

        window.openPremiumLoginModal = function (descriptionText) {
            if (window.SessionProtocolParent) {
                window.SessionProtocolParent.hideOverlay();
            }
            const modal = document.getElementById('premium-login-modal');
            if (!modal) return;
            const descEl = document.getElementById('premium-login-desc');
            if (descEl && descriptionText) {
                descEl.innerText = `You have a premium plan recorded on this device, but you are not logged in. Please sign in to verify your account and use this feature.`;
            }
            modal.style.display = 'flex';

            // Push history state to intercept Android back button
            if (window.history && window.history.pushState) {
                window.history.pushState({ modalId: 'premium-login', premiumModalOpen: true }, "");
            }
        };

        window.closePremiumLoginModal = function (fromPopState = false) {
            const modal = document.getElementById('premium-login-modal');
            if (modal) modal.style.display = 'none';

            // Restore landing page panels if user remains on the active home screen
            const homeView = document.getElementById('view-home');
            if (homeView && homeView.classList.contains('active')) {
                const reveals = homeView.querySelectorAll('.reveal');
                reveals.forEach(rev => {
                    rev.classList.remove('exit-active');
                    rev.classList.remove('active');
                    void rev.offsetWidth; // Force reflow
                    rev.classList.add('active');
                });
            }

            // Pop history state if closed manually (not via popstate)
            if (!fromPopState) {
                if (window.history && window.history.state && window.history.state.modalId === 'premium-login') {
                    window.history.back();
                }
            }
        };

        window.loginPremiumAction = function () {
            window.closePremiumLoginModal(true);
            if (typeof switchView === 'function') {
                switchView('login');
            }
        };

        let isSubPageActive = false;

        /* --- SPA SWITCH VIEW ENGINE (INDEX STYLE CONDITIONAL LOGIC) --- */
        function switchView(view, pushHistoryState = true) {
            if (!view) return false;

            const v = view.toLowerCase();

            // If navigating to subscription view, close the premium unlock modal
            if (v === 'subscription' || v === 'plan and upgrade.html' || v === 'subscription-mobile.html' || v === '#pro-tier') {
                if (typeof closePremiumUnlockModal === 'function') {
                    closePremiumUnlockModal(true);
                }
            }

            // Deactivate and hide session overlay immediately for login and subscription views
            if (
                v === 'login' || v === 'login.html' ||
                v === 'subscription' || v === 'plan and upgrade.html' || v === 'subscription-mobile.html' || v === '#pro-tier'
            ) {
                if (window.SessionProtocolParent) {
                    window.SessionProtocolParent.hideOverlay();
                }
            }

            // Gate Barcode Creator & Decoder for Quantum/Ultra
            if (['barcode-creator', 'barcode', 'qr bloom bar code.html', '#create-barcode', 'barcode-decoder', 'barcode decoder mobile.html', 'qr_bloom_barcode_decoder.html'].includes(v)) {
                const sub = (window.BloomSubscription && typeof window.BloomSubscription.getActivePlan === 'function')
                    ? window.BloomSubscription.getActivePlan()
                    : 'normal';
                if (sub !== 'pro' && sub !== 'ultra') {
                    if (typeof showPremiumUnlockModal === 'function') {
                        const isDecoder = ['barcode-decoder', 'barcode decoder mobile.html', 'qr_bloom_barcode_decoder.html'].includes(v);
                        const featureName = isDecoder ? 'Barcode Decoder' : 'Barcode Creator';
                        const descText = isDecoder
                            ? 'The Barcode Decoder is exclusive to Quantum and Ultra plans. Please upgrade to continue.'
                            : 'The Barcode Creator is exclusive to Quantum and Ultra plans. Please upgrade to continue.';
                        showPremiumUnlockModal('QUANTUM', featureName, descText);
                    }
                    return true;
                }
            }

            // Persist the current view state
            if (typeof safeStorage !== 'undefined') {
                safeStorage.setItem('current_suite_view', view);
            }

            // Security Gate: Check if app is locked and the view is protected
            const protectedViews = [
                'generator', 'qr-creator', 'qr bloom qr code.html',
                'decoder', 'qr-decoder', 'qr decoder.html',
                'barcode-decoder', 'barcode decoder mobile.html', 'qr_bloom_barcode_decoder.html',
                'barcode-creator', 'barcode', 'qr bloom bar code.html', '#create-barcode',
                'settings', 'setting.html', 'setting', '#settings',
                'analytics', 'analysis', 'analytics.html', 'payment', '#payment',
                'why-upgrade', 'why-we-upgrade', 'why we uograde.html', '#why-upgrade',
                'subscription', 'plan and upgrade.html', 'subscription-mobile.html', '#pro-tier',
                'notification', 'notification.html', '#notification',
                'login', 'login.html'
            ];
            const isProtected = protectedViews.includes(v);

            if (window._0x83e2 && window._0x83e2.config && window._0x83e2.config.enabled && isProtected && !window._0x83e2._0x2k8f) {
                let lockScreen = document.getElementById('app-lock-screen');
                if (!lockScreen && window.parent && window.parent.document) {
                    lockScreen = window.parent.document.getElementById('app-lock-screen');
                }
                if (!lockScreen) {
                    console.error("SECURITY BREACH: Lock screen missing. Halting session.");
                    if (typeof closeSPA === 'function') {
                        closeSPA();
                    } else if (window.parent && typeof window.parent.closeSPA === 'function') {
                        window.parent.closeSPA();
                    } else {
                        switchView('landing');
                    }
                    return false;
                }

                if (lockScreen.style.display !== 'flex') {
                    window._0x83e2._0x1b7d = view;
                    window._0x83e2.setLockState(true);
                    return true;
                }
            }

            let templateId = '';
            let viewId = '';
            let frameId = '';

            if (v === 'barcode-creator' || v === 'barcode' || v === 'qr bloom bar code.html' || v === '#create-barcode') {
                templateId = 'barcode-creator-template';
                viewId = 'view-barcode-creator';
                frameId = 'barcode-creator-frame';
            } else if (v === 'barcode-decoder' || v === 'barcode decoder mobile.html' || v === 'qr_bloom_barcode_decoder.html') {
                templateId = 'barcode-decoder-template';
                viewId = 'view-barcode-decoder';
                frameId = 'barcode-decoder-frame';
            } else if (v === 'qr-creator' || v === 'generator' || v === 'qr bloom qr code.html') {
                templateId = 'qr-creator-template';
                viewId = 'view-qr-creator';
                frameId = 'qr-creator-frame';
            } else if (v === 'qr-decoder' || v === 'decoder' || v === 'qr decoder.html') {
                templateId = 'qr-decoder-template';
                viewId = 'view-qr-decoder';
                frameId = 'qr-decoder-frame';
            } else if (v === 'login' || v === 'login.html') {
                templateId = 'login-template';
                viewId = 'view-login';
                frameId = 'login-frame';
            } else if (v === 'feedback' || v === 'feedback.html') {
                templateId = 'feedback-template';
                viewId = 'view-feedback';
                frameId = 'feedback-frame';
            } else if (v === 'privacy' || v === 'privacy.html' || v === 'main policy privacy.html' || v === '#privacy') {
                templateId = 'privacy-template';
                viewId = 'view-privacy';
                frameId = 'privacy-frame';
            } else if (v === 'shortcuts' || v === 'shortcuts-mobile.html' || v === 'setting.html#shortcuts' || v === '#shortcuts') {
                templateId = 'shortcuts-template';
                viewId = 'view-shortcuts';
                frameId = 'shortcuts-frame';
            } else if (v === 'subscription' || v === 'plan and upgrade.html' || v === 'subscription-mobile.html' || v === '#pro-tier') {
                templateId = 'subscription-template';
                viewId = 'view-subscription';
                frameId = 'subscription-frame';
            } else if (v === 'why-upgrade' || v === 'why-we-upgrade' || v === 'why we uograde.html' || v === '#why-upgrade') {
                templateId = 'why-upgrade-template';
                viewId = 'view-why-upgrade';
                frameId = 'why-upgrade-frame';
            } else if (v === 'about' || v === 'about.html' || v === '#about') {
                templateId = 'about-template';
                viewId = 'view-about';
                frameId = 'about-frame';
            } else if (v === 'guide' || v === 'guide.html' || v === '#guide') {
                templateId = 'guide-template';
                viewId = 'view-guide';
                frameId = 'guide-frame';
            } else if (v === 'notification' || v === 'notification.html' || v === '#notification') {
                templateId = 'notification-template';
                viewId = 'view-notification';
                frameId = 'notification-frame';
            } else if (v === 'settings' || v === 'setting.html' || v === '#settings') {
                templateId = 'settings-template';
                viewId = 'view-settings';
                frameId = 'settings-frame';
            } else if (v === 'analytics' || v === 'payment' || v === 'analytics.html' || v === '#payment') {
                templateId = 'analytics-template';
                viewId = 'view-analytics';
                frameId = 'analytics-frame';
            } else if (v === 'dynamic' || v === 'dynamic.html' || v === '#dynamic') {
                templateId = 'dynamic-template';
                viewId = 'view-dynamic';
                frameId = 'dynamic-frame';
            }

            if (templateId) {
                if (pushHistoryState) {
                    const viewToPathMap = {
                        'generator': '/qr-generator',
                        'qr-creator': '/qr-generator',
                        'decoder': '/qr-decoder',
                        'qr-decoder': '/qr-decoder',
                        'barcode-creator': '/barcode-generator',
                        'barcode-decoder': '/barcode-scanner',
                        'analytics': '/analytics',
                        'subscription': '/subscription',
                        'about': '/about',
                        'privacy': '/privacy',
                        'feedback': '/feedback',
                        'notification': '/notification',
                        'guide': '/guide',
                        'shortcuts': '/shortcuts',
                        'login': '/account',
                        'settings': '/settings',
                        'why-upgrade': '/why-upgrade',
                        'dynamic': '/dynamic'
                    };
                    const targetUrl = viewToPathMap[v] || '/';
                    if (isSubPageActive || (history.state && (history.state.modalOpen || history.state.premiumModalOpen || history.state.privacyModalOpen))) {
                        history.replaceState({ spaView: view }, '', targetUrl);
                    } else {
                        history.pushState({ spaView: view }, '', targetUrl);
                    }
                }
                isSubPageActive = true;

                let viewEl = document.getElementById(viewId);
                if (!viewEl) {
                    viewEl = document.createElement('div');
                    viewEl.id = viewId;
                    viewEl.className = 'view-layer';
                    viewEl.style.cssText = 'position: fixed; top: 0; bottom: 0; left: 0; right: 0; z-index: 20000; background: var(--bg-deep); border: none; overflow: hidden; display: none;';

                    const iframe = document.createElement('iframe');
                    iframe.id = frameId;
                    iframe.style.cssText = 'width: 100%; height: 100%; border: none; display: block;';
                    iframe.allowFullscreen = true;
                    iframe.setAttribute('allow', 'fullscreen');

                    // Play bottom-nav sound on clicks inside iframes
                    iframe.addEventListener('load', () => {
                        if (typeof window.syncActiveFontToIframe === 'function') {
                            window.syncActiveFontToIframe(iframe);
                        }
                        try {
                            const doc = iframe.contentDocument || iframe.contentWindow.document;
                            if (doc) {
                                doc.addEventListener('click', (e) => {
                                    const navItem = e.target.closest('.bottom-nav .nav-item');
                                    if (navItem && window.SuiteSounds) {
                                        window.SuiteSounds.play('BOTTOM_NAV');
                                    }
                                }, { capture: true });

                                // Global fullscreen click and touchstart listeners inside iframe
                                doc.addEventListener('click', (e) => {
                                    if (window.parent && typeof window.parent.handleGlobalFullscreenTrigger === 'function') {
                                        window.parent.handleGlobalFullscreenTrigger(e);
                                    }
                                }, { capture: true });

                                doc.addEventListener('touchstart', (e) => {
                                    if (window.parent && typeof window.parent.handleGlobalFullscreenTrigger === 'function') {
                                        window.parent.handleGlobalFullscreenTrigger(e);
                                    }
                                }, { capture: true, passive: true });
                                // Removed change listener
                            }
                        } catch (err) {
                            console.warn("Could not attach bottom nav sound to iframe", err);
                        }
                    });

                    let templateContent = templates[templateId];
                    if (templateContent) {
                        templateContent = templateContent
                            .split('MATCH_CLOSING_SCRIPT').join('</' + 'script>')
                            .split('MATCH_CLOSING_BODY').join('</' + 'body>')
                            .split('MATCH_CLOSING_HTML').join('</' + 'html>');

                        const savedSession = localStorage.getItem('userStoreEnc');
                        if (templateContent.includes('<head>')) {
                            let headInjections = '';
                            if (savedSession) {
                                headInjections += `<script>try { localStorage.setItem('userStoreEnc', '${savedSession}'); } catch(e) {}<\/script>`;
                            }

                            // Inject cleanup handlers and mobile storage keys interceptor
                            headInjections += `
                            <script>
                            // window.APP_SECRET is obsolete
                            window.addEventListener('app-shutdown', function() {
                                if (window.html5QrCode && typeof window.html5QrCode.stop === 'function') {
                                    try { window.html5QrCode.stop().catch(()=>{}); } catch(e) {}
                                }
                                if (window.html5QrCodeScanner && typeof window.html5QrCodeScanner.clear === 'function') {
                                    try { window.html5QrCodeScanner.clear().catch(()=>{}); } catch(e) {}
                                }
                            });
                                (function() {
                                    const originalGet = Storage.prototype.getItem;
                                    const originalSet = Storage.prototype.setItem;
                                    const originalRemove = Storage.prototype.removeItem;
                                    const keys = ['active_layer_mode', 'suite_sound_muted', 'suite_sound_volume', 'suite_typing_enabled', 'suite_typing_volume', 'suite_typing_tune', 'suite_bottom_nav_enabled', 'suite_bottom_nav_volume', 'nav_anim_enabled', 'session_protocol_enabled', 'fullscreen_on_click'];
                                    const restrictedKeys = ['dynamic_qr_stats', 'had_premium_plan', 'last_notified_subscription', 'qr_batch_usage', 'qr_dynamic', 'qr_selected_type', 'qr_total_created', 'qr_total_decoded', 'qrbloom_scanned_dyn_qrs', 'user_subscription'];

                                    function getVerifiedPlan() {
                                        try {
                                            const p = window.parent;
                                            if (p && p.BloomSubscription && typeof p.BloomSubscription.getActivePlan === 'function') {
                                                return p.BloomSubscription.getActivePlan();
                                            }
                                            if (p && typeof p.getVerifiedPlanFromCache === 'function') {
                                                return p.getVerifiedPlanFromCache();
                                            }
                                        } catch(e) {}
                                        return 'normal';
                                    }

                                    // Purge restricted keys on startup & install property traps
                                    restrictedKeys.forEach(rk => {
                                        try { originalRemove.call(localStorage, rk); } catch(e) {}
                                        const desc = {
                                            get: function () {
                                                if (rk === 'user_subscription') return getVerifiedPlan();
                                                if (rk === 'had_premium_plan') return 'false';
                                                return undefined;
                                            },
                                            set: function (val) {
                                                try { originalRemove.call(this, rk); } catch (e) { }
                                                try { originalRemove.call(localStorage, rk); } catch (e) { }
                                                if (rk === 'user_subscription') {
                                                    const authenticPlan = getVerifiedPlan();
                                                    window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: authenticPlan } }));
                                                    window.dispatchEvent(new CustomEvent('qrbloom_plan_tampered', { detail: { plan: authenticPlan } }));
                                                    if (typeof handlePlanChangeRefresh === 'function') handlePlanChangeRefresh();
                                                }
                                            },
                                            configurable: true,
                                            enumerable: true
                                         };
                                         try { Object.defineProperty(Storage.prototype, rk, desc); } catch(e) {}
                                         try { Object.defineProperty(localStorage, rk, desc); } catch(e) {}
                                    });

                                    Storage.prototype.getItem = function(k) {
                                        if (k === 'user_subscription') return getVerifiedPlan();
                                        if (k === 'premiumActive') {
                                            const p = window.parent;
                                            if (p && p.BloomSubscription && typeof p.BloomSubscription.isPlanActive === 'function') {
                                                return p.BloomSubscription.isPlanActive() ? 'true' : 'false';
                                            }
                                            return getVerifiedPlan() !== 'normal' ? 'true' : 'false';
                                        }
                                        if (k === 'had_premium_plan') return 'false';
                                        if (k === 'qr_batch_usage') {
                                            const p = window.parent;
                                            return String((p && p._qrbloom_batch_usage !== undefined) ? p._qrbloom_batch_usage : (window._qrbloom_batch_usage || 0));
                                        }
                                        if (k === 'qr_dynamic') {
                                            const p = window.parent;
                                            return String((p && p._qrbloom_dynamic_usage !== undefined) ? p._qrbloom_dynamic_usage : (window._qrbloom_dynamic_usage || 0));
                                        }
                                        if (k === 'qr_selected_type') {
                                            const p = window.parent;
                                            return (p && p._qrbloom_selected_type) ? p._qrbloom_selected_type : (window._qrbloom_selected_type || 'text');
                                        }
                                        if (k === 'qr_total_created') {
                                            const p = window.parent;
                                            return String((p && p._qrbloom_total_created !== undefined) ? p._qrbloom_total_created : (window._qrbloom_total_created || 0));
                                        }
                                        if (k === 'qr_total_decoded') {
                                            const p = window.parent;
                                            return String((p && p._qrbloom_total_decoded !== undefined) ? p._qrbloom_total_decoded : (window._qrbloom_total_decoded || 0));
                                        }
                                        if (k === 'dynamic_qr_stats') {
                                            const p = window.parent;
                                            return JSON.stringify((p && p._qrbloom_dynamic_qr_stats) ? p._qrbloom_dynamic_qr_stats : (window._qrbloom_dynamic_qr_stats || {}));
                                        }
                                        if (k === 'qrbloom_scanned_dyn_qrs') {
                                            const p = window.parent;
                                            return JSON.stringify(Array.from((p && p._qrbloom_scanned_dyn_qrs) ? p._qrbloom_scanned_dyn_qrs : (window._qrbloom_scanned_dyn_qrs || [])));
                                        }
                                        if (keys.includes(k)) return originalGet.call(this, 'mobile_' + k);
                                        return originalGet.call(this, k);
                                    };

                                    Storage.prototype.setItem = function(k, v) {
                                        if (restrictedKeys.includes(k)) {
                                            originalRemove.call(this, k);
                                            if (k === 'qr_selected_type') {
                                                window._qrbloom_selected_type = v;
                                                if (window.parent) window.parent._qrbloom_selected_type = v;
                                            } else if (k === 'qr_batch_usage') {
                                                const num = parseInt(v) || 0;
                                                window._qrbloom_batch_usage = num;
                                                if (window.parent) {
                                                    window.parent._qrbloom_batch_usage = num;
                                                    if (window.parent.syncBatchUsageToFirebase) window.parent.syncBatchUsageToFirebase(num);
                                                }
                                            } else if (k === 'qr_dynamic') {
                                                const num = parseInt(v) || 0;
                                                window._qrbloom_dynamic_usage = num;
                                                if (window.parent) {
                                                    window.parent._qrbloom_dynamic_usage = num;
                                                    if (window.parent.syncDynamicUsageToFirebase) window.parent.syncDynamicUsageToFirebase(num);
                                                }
                                            }
                                            if (k === 'user_subscription') {
                                                if (typeof handlePlanChangeRefresh === 'function') handlePlanChangeRefresh();
                                            }
                                            return;
                                        }
                                        if (keys.includes(k)) return originalSet.call(this, 'mobile_' + k, v);
                                        return originalSet.call(this, k, v);
                                    };

                                    Storage.prototype.removeItem = function(k) {
                                        if (keys.includes(k)) return originalRemove.call(this, 'mobile_' + k);
                                        return originalRemove.call(this, k);
                                    };

                                    // Active iframe tamper guard: continuously purges restricted keys and instantly resets UI
                                    function purgeAndRevertIframe() {
                                        let tampered = false;
                                        for (const rk of restrictedKeys) {
                                            if (originalGet.call(localStorage, rk) !== null) {
                                                originalRemove.call(localStorage, rk);
                                                tampered = true;
                                            }
                                        }
                                        if (tampered) {
                                            const authenticPlan = getVerifiedPlan();
                                            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: authenticPlan, newValue: authenticPlan } }));
                                            window.dispatchEvent(new CustomEvent('qrbloom_plan_tampered', { detail: { plan: authenticPlan } }));
                                            if (typeof handlePlanChangeRefresh === 'function') {
                                                handlePlanChangeRefresh();
                                            }
                                        }
                                    }
                                    purgeAndRevertIframe();
                                    setInterval(purgeAndRevertIframe, 150);
                                    window.addEventListener('storage', purgeAndRevertIframe);
                                })();
                            <\/script>
                            <link href="https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,200..800&family=Inter:wght@400;500;600&family=Lato:wght@300;400;700;900&family=Lora:ital,wght@1,400;1,500;1,600;1,700&family=Merriweather:ital,wght@1,300;1,400;1,700&family=Montserrat:wght@300;400;500;600;700;800&family=Space+Grotesk:wght@500;600;700&display=swap" rel="stylesheet">
                            <link href="https://api.fontshare.com/v2/css?f[]=clash-display@200,300,400,500,600,700&display=swap" rel="stylesheet">
                            <style id="neural-fonts-stylesheet">
                                html body.font-mode-1, html body.font-mode-1 *:not(.material-symbols-outlined) { font-family: 'Space Grotesk', sans-serif !important; font-style: normal !important; }
                                html body.font-mode-2, html body.font-mode-2 *:not(.material-symbols-outlined) { font-family: 'Montserrat', sans-serif !important; font-style: normal !important; }
                                html body.font-mode-3, html body.font-mode-3 *:not(.material-symbols-outlined) { font-family: 'Inter', sans-serif !important; font-style: normal !important; }
                                html body.font-mode-4, html body.font-mode-4 *:not(.material-symbols-outlined) { font-family: 'Lato', sans-serif !important; font-style: normal !important; }
                                html body.font-mode-5, html body.font-mode-5 *:not(.material-symbols-outlined) { font-family: 'Merriweather', serif !important; font-style: italic !important; }
                                html body.font-mode-6, html body.font-mode-6 *:not(.material-symbols-outlined) { font-family: 'Lora', serif !important; font-style: italic !important; }
                                html body.font-mode-7, html body.font-mode-7 *:not(.material-symbols-outlined) { font-family: 'Clash Display', sans-serif !important; font-style: normal !important; }
                                html body.font-mode-8, html body.font-mode-8 *:not(.material-symbols-outlined) { font-family: 'Bricolage Grotesque', sans-serif !important; font-style: normal !important; }
                            </style>`;

                            templateContent = templateContent.replace('<head>', '<head>' + headInjections);
                        }

                        iframe.srcdoc = templateContent;
                    }

                    viewEl.appendChild(iframe);
                    document.body.appendChild(viewEl);
                } else {
                    const iframe = document.getElementById(frameId);
                    if (iframe && !iframe.srcdoc) {
                        let templateContent = templates[templateId];
                        if (templateContent) {
                            templateContent = templateContent
                                .split('MATCH_CLOSING_SCRIPT').join('</' + 'script>')
                                .split('MATCH_CLOSING_BODY').join('</' + 'body>')
                                .split('MATCH_CLOSING_HTML').join('</' + 'html>');

                            const savedSession = localStorage.getItem('userStoreEnc');
                            if (templateContent.includes('<head>')) {
                                let headInjections = '';
                                if (savedSession) {
                                    headInjections += `<script>try { localStorage.setItem('userStoreEnc', '${savedSession}'); } catch(e) {}<\/script>`;
                                }

                                // Inject cleanup handlers and mobile storage keys interceptor
                                headInjections += `
                                <script>
                                // window.APP_SECRET is obsolete
                                window.addEventListener('app-shutdown', function() {
                                    if (window.html5QrCode && typeof window.html5QrCode.stop === 'function') {
                                        try { window.html5QrCode.stop().catch(()=>{}); } catch(e) {}
                                    }
                                    if (window.html5QrCodeScanner && typeof window.html5QrCodeScanner.clear === 'function') {
                                        try { window.html5QrCodeScanner.clear().catch(()=>{}); } catch(e) {}
                                    }
                                });
                                (function() {
                                    const originalGet = Storage.prototype.getItem;
                                    const originalSet = Storage.prototype.setItem;
                                    const originalRemove = Storage.prototype.removeItem;
                                    const keys = ['active_layer_mode', 'suite_sound_muted', 'suite_sound_volume', 'suite_typing_enabled', 'suite_typing_volume', 'suite_typing_tune', 'suite_bottom_nav_enabled', 'suite_bottom_nav_volume', 'nav_anim_enabled', 'session_protocol_enabled', 'fullscreen_on_click'];
                                    const restrictedKeys = ['dynamic_qr_stats', 'had_premium_plan', 'last_notified_subscription', 'qr_batch_usage', 'qr_dynamic', 'qr_selected_type', 'qr_total_created', 'qr_total_decoded', 'qrbloom_scanned_dyn_qrs', 'user_subscription'];

                                    function getVerifiedPlan() {
                                        try {
                                            const p = window.parent;
                                            if (p && p.BloomSubscription && typeof p.BloomSubscription.getActivePlan === 'function') {
                                                return p.BloomSubscription.getActivePlan();
                                            }
                                            if (p && typeof p.getVerifiedPlanFromCache === 'function') {
                                                return p.getVerifiedPlanFromCache();
                                            }
                                        } catch(e) {}
                                        return 'normal';
                                    }

                                    // Purge restricted keys on startup & install property traps
                                    restrictedKeys.forEach(rk => {
                                        try { originalRemove.call(localStorage, rk); } catch(e) {}
                                        const desc = {
                                            get: function () {
                                                if (rk === 'user_subscription') return getVerifiedPlan();
                                                if (rk === 'had_premium_plan') return 'false';
                                                return undefined;
                                            },
                                            set: function (val) {
                                                try { originalRemove.call(this, rk); } catch (e) { }
                                                try { originalRemove.call(localStorage, rk); } catch (e) { }
                                                if (rk === 'user_subscription') {
                                                    const authenticPlan = getVerifiedPlan();
                                                    window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: authenticPlan } }));
                                                    window.dispatchEvent(new CustomEvent('qrbloom_plan_tampered', { detail: { plan: authenticPlan } }));
                                                    if (typeof handlePlanChangeRefresh === 'function') handlePlanChangeRefresh();
                                                }
                                            },
                                            configurable: true,
                                            enumerable: true
                                         };
                                         try { Object.defineProperty(Storage.prototype, rk, desc); } catch(e) {}
                                         try { Object.defineProperty(localStorage, rk, desc); } catch(e) {}
                                    });

                                    Storage.prototype.getItem = function(k) {
                                        if (k === 'user_subscription') return getVerifiedPlan();
                                        if (k === 'premiumActive') {
                                            const p = window.parent;
                                            if (p && p.BloomSubscription && typeof p.BloomSubscription.isPlanActive === 'function') {
                                                return p.BloomSubscription.isPlanActive() ? 'true' : 'false';
                                            }
                                            return getVerifiedPlan() !== 'normal' ? 'true' : 'false';
                                        }
                                        if (k === 'had_premium_plan') return 'false';
                                        if (k === 'qr_batch_usage') {
                                            const p = window.parent;
                                            return String((p && p._qrbloom_batch_usage !== undefined) ? p._qrbloom_batch_usage : (window._qrbloom_batch_usage || 0));
                                        }
                                        if (k === 'qr_dynamic') {
                                            const p = window.parent;
                                            return String((p && p._qrbloom_dynamic_usage !== undefined) ? p._qrbloom_dynamic_usage : (window._qrbloom_dynamic_usage || 0));
                                        }
                                        if (k === 'qr_selected_type') {
                                            const p = window.parent;
                                            return (p && p._qrbloom_selected_type) ? p._qrbloom_selected_type : (window._qrbloom_selected_type || 'text');
                                        }
                                        if (k === 'qr_total_created') {
                                            const p = window.parent;
                                            return String((p && p._qrbloom_total_created !== undefined) ? p._qrbloom_total_created : (window._qrbloom_total_created || 0));
                                        }
                                        if (k === 'qr_total_decoded') {
                                            const p = window.parent;
                                            return String((p && p._qrbloom_total_decoded !== undefined) ? p._qrbloom_total_decoded : (window._qrbloom_total_decoded || 0));
                                        }
                                        if (k === 'dynamic_qr_stats') {
                                            const p = window.parent;
                                            return JSON.stringify((p && p._qrbloom_dynamic_qr_stats) ? p._qrbloom_dynamic_qr_stats : (window._qrbloom_dynamic_qr_stats || {}));
                                        }
                                        if (k === 'qrbloom_scanned_dyn_qrs') {
                                            const p = window.parent;
                                            return JSON.stringify(Array.from((p && p._qrbloom_scanned_dyn_qrs) ? p._qrbloom_scanned_dyn_qrs : (window._qrbloom_scanned_dyn_qrs || [])));
                                        }
                                        if (keys.includes(k)) return originalGet.call(this, 'mobile_' + k);
                                        return originalGet.call(this, k);
                                    };

                                    Storage.prototype.setItem = function(k, v) {
                                        if (restrictedKeys.includes(k)) {
                                            originalRemove.call(this, k);
                                            if (k === 'qr_selected_type') {
                                                window._qrbloom_selected_type = v;
                                                if (window.parent) window.parent._qrbloom_selected_type = v;
                                            } else if (k === 'qr_batch_usage') {
                                                const num = parseInt(v) || 0;
                                                window._qrbloom_batch_usage = num;
                                                if (window.parent) {
                                                    window.parent._qrbloom_batch_usage = num;
                                                    if (window.parent.syncBatchUsageToFirebase) window.parent.syncBatchUsageToFirebase(num);
                                                }
                                            } else if (k === 'qr_dynamic') {
                                                const num = parseInt(v) || 0;
                                                window._qrbloom_dynamic_usage = num;
                                                if (window.parent) {
                                                    window.parent._qrbloom_dynamic_usage = num;
                                                    if (window.parent.syncDynamicUsageToFirebase) window.parent.syncDynamicUsageToFirebase(num);
                                                }
                                            }
                                            if (k === 'user_subscription') {
                                                if (typeof handlePlanChangeRefresh === 'function') handlePlanChangeRefresh();
                                            }
                                            return;
                                        }
                                        if (keys.includes(k)) return originalSet.call(this, 'mobile_' + k, v);
                                        return originalSet.call(this, k, v);
                                    };

                                    Storage.prototype.removeItem = function(k) {
                                        if (keys.includes(k)) return originalRemove.call(this, 'mobile_' + k);
                                        return originalRemove.call(this, k);
                                    };

                                    // Active iframe tamper guard: continuously purges restricted keys and instantly resets UI
                                    function purgeAndRevertIframe() {
                                        let tampered = false;
                                        for (const rk of restrictedKeys) {
                                            if (originalGet.call(localStorage, rk) !== null) {
                                                originalRemove.call(localStorage, rk);
                                                tampered = true;
                                            }
                                        }
                                        if (tampered) {
                                            const authenticPlan = getVerifiedPlan();
                                            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: authenticPlan, newValue: authenticPlan } }));
                                            window.dispatchEvent(new CustomEvent('qrbloom_plan_tampered', { detail: { plan: authenticPlan } }));
                                            if (typeof handlePlanChangeRefresh === 'function') {
                                                handlePlanChangeRefresh();
                                            }
                                        }
                                    }
                                    purgeAndRevertIframe();
                                    setInterval(purgeAndRevertIframe, 150);
                                    window.addEventListener('storage', purgeAndRevertIframe);
                                })();
                                <\/script>
                                <link href="https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,200..800&family=Inter:wght@400;500;600&family=Lato:wght@300;400;700;900&family=Lora:ital,wght@1,400;1,500;1,600;1,700&family=Merriweather:ital,wght@1,300;1,400;1,700&family=Montserrat:wght@300;400;500;600;700;800&family=Space+Grotesk:wght@500;600;700&display=swap" rel="stylesheet">
                                <link href="https://api.fontshare.com/v2/css?f[]=clash-display@200,300,400,500,600,700&display=swap" rel="stylesheet">
                                <style id="neural-fonts-stylesheet">
                                    html body.font-mode-1, html body.font-mode-1 *:not(.material-symbols-outlined) { font-family: 'Space Grotesk', sans-serif !important; font-style: normal !important; }
                                    html body.font-mode-2, html body.font-mode-2 *:not(.material-symbols-outlined) { font-family: 'Montserrat', sans-serif !important; font-style: normal !important; }
                                    html body.font-mode-3, html body.font-mode-3 *:not(.material-symbols-outlined) { font-family: 'Inter', sans-serif !important; font-style: normal !important; }
                                    html body.font-mode-4, html body.font-mode-4 *:not(.material-symbols-outlined) { font-family: 'Lato', sans-serif !important; font-style: normal !important; }
                                    html body.font-mode-5, html body.font-mode-5 *:not(.material-symbols-outlined) { font-family: 'Merriweather', serif !important; font-style: italic !important; }
                                    html body.font-mode-6, html body.font-mode-6 *:not(.material-symbols-outlined) { font-family: 'Lora', serif !important; font-style: italic !important; }
                                    html body.font-mode-7, html body.font-mode-7 *:not(.material-symbols-outlined) { font-family: 'Clash Display', sans-serif !important; font-style: normal !important; }
                                    html body.font-mode-8, html body.font-mode-8 *:not(.material-symbols-outlined) { font-family: 'Bricolage Grotesque', sans-serif !important; font-style: normal !important; }
                                </style>`;
                                templateContent = templateContent.replace('<head>', '<head>' + headInjections);
                            }
                            iframe.srcdoc = templateContent;
                        }
                    }
                }

                // Deactivate all view layers and explicitly hide them to override inline styles
                // ── LAZY FREEZE: Stop background scripts in non-active iframes ──
                document.querySelectorAll('.view-layer').forEach(view => {
                    view.classList.remove('active');
                    view.style.display = 'none';
                    // Clear srcdoc of non-active iframes to kill all running JS (timers, listeners, animations)
                    // Template will reload from DOM <script type="text/plain"> on next visit (no network refetch)
                    if (view.id !== viewId) {
                        const iframeEl = view.querySelector('iframe');
                        if (iframeEl && iframeEl.srcdoc) {
                            iframeEl.srcdoc = '';
                        }
                    }
                });
                document.querySelectorAll('.bottom-nav .nav-item').forEach(nav => nav.classList.remove('active'));

                viewEl.classList.add('active');
                viewEl.style.display = 'block'; // Force display: block for full-screen fixed view

                // Dynamic view sits above desktop lock modal (z-index 99999) so only dynamic QR page is accessible on desktop
                if (viewId === 'view-dynamic') {
                    viewEl.style.zIndex = '100001';
                } else {
                    viewEl.style.zIndex = '20000';
                }
                document.documentElement.classList.remove('route-dynamic');
                document.body.classList.remove('route-dynamic', 'view-dynamic-active');
                const desktopLockEl = document.querySelector('.desktop-lock');
                if (desktopLockEl) desktopLockEl.classList.remove('hidden-for-dynamic');

                // Ensure active font is synced to the iframe immediately upon switching
                const activeIframe = document.getElementById(frameId);
                if (activeIframe) {
                    if (typeof window.syncActiveFontToIframe === 'function') {
                        window.syncActiveFontToIframe(activeIframe);
                    }
                }

                // Highlight corresponding bottom-nav tab if matched
                if (v === 'barcode-creator' || v === 'barcode' || v === 'qr bloom bar code.html' || v === '#create-barcode') {
                    const nav = document.getElementById('nav-home');
                    if (nav) nav.classList.add('active');
                } else if (v === 'barcode-decoder' || v === 'decoder' || v === 'qr decoder.html' || v === 'barcode_reader' || v === 'why-upgrade' || v === 'why-we-upgrade' || v === 'why we uograde.html' || v === '#why-upgrade' || v === 'subscription' || v === 'plan and upgrade.html' || v === 'subscription-mobile.html' || v === '#pro-tier') {
                    const nav = document.getElementById('nav-sub');
                    if (nav) nav.classList.add('active');
                } else if (v === 'analytics' || v === 'payment' || v === 'analytics.html' || v === '#payment') {
                    const nav = document.getElementById('nav-batch');
                    if (nav) nav.classList.add('active');
                } else if (v === 'settings' || v === 'setting.html' || v === '#settings') {
                    const nav = document.getElementById('nav-settings');
                    if (nav) nav.classList.add('active');
                }

                // Hide modal if open
                const actionModal = document.getElementById('action-modal');
                if (actionModal) actionModal.classList.remove('active');

                return true;
            }
            return false;
        }

        window.closeSPA = function (fromPopState = false) {
            isSubPageActive = false;

            document.documentElement.classList.remove('route-dynamic');
            document.body.classList.remove('route-dynamic', 'view-dynamic-active');
            const desktopLockEl = document.querySelector('.desktop-lock');
            if (desktopLockEl) desktopLockEl.classList.remove('hidden-for-dynamic');

            if (typeof window.safeStorage !== 'undefined') {
                window.safeStorage.setItem('current_suite_view', 'landing');
            } else {
                localStorage.setItem('current_suite_view', 'landing');
            }

            const navItems = document.querySelectorAll('.bottom-nav .nav-item');
            const viewLayers = document.querySelectorAll('.view-layer');

            navItems.forEach(nav => nav.classList.remove('active'));
            const homeNav = document.getElementById('nav-home');
            if (homeNav) homeNav.classList.add('active');

            viewLayers.forEach(view => {
                view.classList.remove('active');
                view.style.display = 'none';
                view.style.zIndex = '20000';
            });
            const homeView = document.getElementById('view-home');
            if (homeView) {
                homeView.classList.add('active');
                homeView.style.display = 'block';
                // Trigger entry animation again
                const reveals = homeView.querySelectorAll('.reveal');
                reveals.forEach(rev => {
                    rev.classList.remove('exit-active');
                    rev.classList.remove('active');
                    void rev.offsetWidth;
                    rev.classList.add('active');
                });
            }

            // Clean up dynamic frames to release memory and stop all background scripts
            document.querySelectorAll('.view-layer iframe').forEach(iframe => {
                if (iframe.srcdoc) {
                    iframe.srcdoc = '';
                }
            });

            if (!fromPopState) {
                if (window.history && window.history.state && window.history.state.spaView) {
                    window.isClosingSPA = true;
                    history.back();
                    // Failsafe: if history.back() doesn't fire popstate (e.g. if root history was overwritten)
                    setTimeout(() => {
                        if (window.isClosingSPA) {
                            window.isClosingSPA = false;
                            window.history.replaceState(null, '', '/');
                        }
                    }, 50);
                } else {
                    // Ensure URL is reset to root even if state was lost
                    window.history.replaceState(null, '', '/');
                }
            } else {
                if (window.location.pathname.toLowerCase().startsWith('/dynamic') || window.location.search.toLowerCase().includes('dynamic') || window.location.hash.toLowerCase().includes('dynamic')) {
                    window.history.replaceState(null, '', '/');
                }
            }
        };

        window.openMainPrivacyPolicy = function (origin, sectionId) {
            switchView('privacy');
            const targetSection = sectionId || 'privacy-section';
            const checkFrame = () => {
                const privacyFrame = document.getElementById('privacy-frame');
                if (privacyFrame) {
                    let attempts = 0;
                    const maxAttempts = 100; // 5 seconds max
                    const tryScroll = () => {
                        try {
                            const iframeDoc = privacyFrame.contentDocument || privacyFrame.contentWindow.document;
                            if (iframeDoc) {
                                const target = iframeDoc.getElementById(targetSection);
                                if (target) {
                                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                    return;
                                }
                            }
                        } catch (e) {
                            console.warn('Scroll attempt failed:', e);
                        }
                        attempts++;
                        if (attempts < maxAttempts) {
                            setTimeout(tryScroll, 50);
                        }
                    };
                    tryScroll();
                } else {
                    setTimeout(checkFrame, 50);
                }
            };
            checkFrame();
        };


        // ─── Privacy Toast ─────────────────────────────────────────────
        window.handlePrivacyToast = function (choice, fromPopState = false) {
            const toast = document.getElementById('privacy-toast');
            const backdrop = document.getElementById('privacy-toast-backdrop');
            if (!toast) return;

            // Record choice
            if (window.recordUserChoice) window.recordUserChoice('privacy', choice);

            // ── 1. Always persist to localStorage ─────────────────────────
            if (choice === 'allow' || choice === 'never') {
                localStorage.setItem('privacy_persistent_choice', choice);
            }

            // ── 2. Write into user_choices map (merged into Firebase on login) ─
            // This means: if user is logged out now, it gets pushed when they login.
            // ── 2. Write into user_choices map (merged into Firebase on login) ─
            // This means: if user is logged out now, it gets pushed when they login.
            try {
                const existingChoices = JSON.parse(localStorage.getItem('user_choices') || '{}');
                existingChoices.privacy = {
                    choice: choice,
                    timestamp: new Date().toISOString(),
                    device: 'mobile'
                };
                if (existingChoices.mobile) {
                    delete existingChoices.mobile;
                }
                localStorage.setItem('user_choices', JSON.stringify(existingChoices));
            } catch (e) { }

            // ── 3. If already logged in → push to Firestore immediately ────
            try {
                const auth = window.suiteAuth;
                const db = window.suiteDb;
                const user = auth && auth.currentUser;
                if (user && db && window.suiteUpdateDoc && window.suiteDoc) {
                    const updateObj = {
                        'choices.privacy': {
                            choice: choice,
                            timestamp: new Date().toISOString(),
                            device: 'mobile'
                        }
                    };
                    if (window.suiteDeleteField) {
                        updateObj['choices.mobile'] = window.suiteDeleteField();
                    }
                    window.suiteUpdateDoc(
                        window.suiteDoc(db, 'users', user.uid),
                        updateObj
                    ).catch(() => { }); // silent fail — localStorage is the fallback
                }
            } catch (e) { }

            if (!fromPopState) {
                if (choice === 'review') {
                    // Keep toast open; navigate to policy
                    if (typeof window.openMainPrivacyPolicy === 'function') window.openMainPrivacyPolicy('toast');
                    else if (typeof openPolicy === 'function') openPolicy();
                    return;
                }
            }

            // ── Close animation — fling down from current position ──
            const currentTransform = toast.style.transform;
            toast.style.transition = 'opacity 0.3s ease, transform 0.35s cubic-bezier(0.55,0,1,0.45)';
            toast.style.transform = currentTransform.replace(/translateY\([^)]*\)/, 'translateY(130px)')
                || 'translateX(-50%) translateY(130px)';
            toast.style.opacity = '0';

            // Fade out backdrop
            if (backdrop) {
                backdrop.style.opacity = '0';
                setTimeout(() => { backdrop.style.display = 'none'; }, 350);
            }

            setTimeout(() => {
                toast.style.display = 'none';
                toast.style.transition = '';
            }, 380);
        };

        // ─── Drag logic: free 2D movement, clamped to screen ───────────────
        function _attachPrivacyDrag() {
            const toast = document.getElementById('privacy-toast');
            if (!toast) return;

            // Live offset from the card's resting (bottom-center) position
            // Positive offsetX = moved right; positive offsetY = moved down.
            let offsetX = 0, offsetY = 0;

            // Pointer state
            let isDragging = false;
            let startPX = 0, startPY = 0;   // pointer coords at drag start
            let startOX = 0, startOY = 0;   // offsetX/Y at drag start
            let dragDeltaY = 0;             // raw vertical drag from start (unclamped)

            function getClient(e) {
                const src = e.touches ? e.touches[0] : e;
                return { x: src.clientX, y: src.clientY };
            }

            // Apply current offsets to the element
            function applyTransform(extraY) {
                const ey = extraY || 0;
                toast.style.transform = `translateX(calc(-50% + ${offsetX}px)) translateY(${offsetY + ey}px)`;
            }

            // Clamp X and upward Y — but NOT downward (so swipe-down-to-dismiss works)
            function clampOffsets() {
                const W = window.innerWidth;
                const H = window.innerHeight;
                const cW = toast.offsetWidth || 340;
                const cH = toast.offsetHeight || 220;

                const homeLeft = (W - cW) / 2;
                const maxRight = W - homeLeft - cW;
                const maxLeft = -homeLeft;

                const paddingB = 16;
                const homeTop = H - cH - paddingB;
                const maxUp = -homeTop;           // can drag up to top of screen

                // Clamp X fully, clamp upward Y — allow any downward drag (no maxDown clamp)
                offsetX = Math.max(maxLeft, Math.min(offsetX, maxRight));
                offsetY = Math.max(maxUp, offsetY);  // only block going above screen top
            }

            const SWIPE_DOWN_HOME = 80;   // px downward from start → snap to home
            const SWIPE_DOWN_DISMISS = 200; // px downward from start → dismiss

            function onDragStart(e) {
                const tag = e.target.tagName;
                if (tag === 'BUTTON' || tag === 'A') return;
                if (tag === 'SPAN' && typeof e.target.onclick === 'function') return;

                isDragging = true;
                const pt = getClient(e);
                startPX = pt.x;
                startPY = pt.y;
                startOX = offsetX;
                startOY = offsetY;
                dragDeltaY = 0;

                toast.style.transition = 'none';
                const pill = toast.querySelector('#privacy-drag-handle div');
                if (pill) pill.style.background = 'rgba(255,255,255,0.5)';
            }

            function onDragMove(e) {
                if (!isDragging) return;
                const pt = getClient(e);

                dragDeltaY = pt.y - startPY;         // raw vertical drag from start point
                offsetX = startOX + (pt.x - startPX);
                offsetY = startOY + dragDeltaY;
                clampOffsets();
                applyTransform();

                // Fade card slightly as user swipes downward past home threshold
                if (dragDeltaY > SWIPE_DOWN_HOME) {
                    const progress = Math.min(1, (dragDeltaY - SWIPE_DOWN_HOME) / (SWIPE_DOWN_DISMISS - SWIPE_DOWN_HOME));
                    toast.style.opacity = (1 - progress * 0.6).toString();
                } else {
                    toast.style.opacity = '1';
                }

                if (e.cancelable) e.preventDefault();
            }

            function onDragEnd() {
                if (!isDragging) return;
                isDragging = false;

                const pill = toast.querySelector('#privacy-drag-handle div');
                if (pill) pill.style.background = 'rgba(255,255,255,0.22)';

                // ── Swipe-down gestures ──────────────────────────────────
                if (dragDeltaY >= SWIPE_DOWN_DISMISS) {
                    // Flung far enough down → dismiss
                    window.handlePrivacyToast('deny');
                    return;
                }

                if (dragDeltaY >= SWIPE_DOWN_HOME) {
                    // Moderate downward swipe → snap BACK to default home (bottom-center)
                    toast.style.transition = 'transform 0.45s cubic-bezier(0.34,1.56,0.64,1), opacity 0.25s ease';
                    toast.style.opacity = '1';
                    offsetX = 0;
                    offsetY = 0;
                    applyTransform();
                    return;
                }

                // ── Released anywhere else → STAY at current position ───
                toast.style.transition = 'transform 0.2s ease-out, opacity 0.15s ease';
                toast.style.opacity = '1';
                // offsetX / offsetY already hold the released position — just keep them
                applyTransform();
            }

            // Touch
            toast.addEventListener('touchstart', onDragStart, { passive: true });
            toast.addEventListener('touchmove', onDragMove, { passive: false });
            toast.addEventListener('touchend', onDragEnd, { passive: true });
            // Mouse
            toast.addEventListener('mousedown', onDragStart);
            document.addEventListener('mousemove', onDragMove);
            document.addEventListener('mouseup', onDragEnd);
        }

        // ─── Init ───────────────────────────────────────────────────────
        function initPrivacyToast() {
            const toast = document.getElementById('privacy-toast');
            const backdrop = document.getElementById('privacy-toast-backdrop');
            if (!toast) return;

            // Skip if user already chose allow/never
            const choice = localStorage.getItem('privacy_persistent_choice');
            if (choice === 'allow' || choice === 'never') return;

            _attachPrivacyDrag();

            // Show after 1.5s with spring slide-up
            setTimeout(() => {
                // Backdrop: just display it (no blocking, no blur — app stays interactive)
                if (backdrop) {
                    backdrop.style.display = 'block';
                }
                // Show toast — slide up from bottom-center
                toast.style.display = 'block';
                toast.offsetHeight;    // reflow
                toast.style.opacity = '1';
                toast.style.transform = 'translateX(-50%) translateY(0)';
            }, 1500);
        }

        window.addEventListener('load', initPrivacyToast);


        window.addEventListener('popstate', (event) => {
            const premiumModal = document.getElementById('premium-unlock-modal');
            if (premiumModal && premiumModal.style.display === 'flex') {
                window.closePremiumUnlockModal(true);
                return;
            }
            const premiumLoginModal = document.getElementById('premium-login-modal');
            if (premiumLoginModal && premiumLoginModal.style.display === 'flex') {
                window.closePremiumLoginModal(true);
                return;
            }
            if (isClosingActionModal) {
                isClosingActionModal = false;
                return;
            }
            const actionModal = document.getElementById('action-modal');
            if (actionModal && actionModal.classList.contains('active')) {
                actionModal.classList.remove('active');
                return;
            }
            if (window.isClosingSPA) {
                if (event.state && event.state.spaView) {
                    history.back();
                } else {
                    window.isClosingSPA = false;
                    closeSPA(true);
                }
                return;
            }
            if (isSubPageActive) {
                if (!event.state || !event.state.spaView) {
                    // Popped back to landing page
                    closeSPA(true);
                } else if (event.state.spaView) {
                    // Popped back to a different sub-view
                    switchView(event.state.spaView, false);
                }
            } else if (event.state && event.state.spaView) {
                switchView(event.state.spaView, false);
            } else {
                closeSPA(true);
            }
        });



        const navItems = document.querySelectorAll('.bottom-nav .nav-item');
        const viewLayers = document.querySelectorAll('.view-layer');

        navItems.forEach((item, index) => {

            if (index === 2) return;

            item.addEventListener('click', () => {
                const href = item.getAttribute('data-href');
                const homeView = document.getElementById('view-home');
                const isCurrentlyHome = homeView && homeView.classList.contains('active');

                let isTargetHome = false;
                if (href) {
                    const v = href.toLowerCase();
                    if (v === 'barcode-creator' || v === 'barcode' || v === 'qr bloom bar code.html' || v === '#create-barcode') {
                        isTargetHome = false;
                    }
                } else if (index === 0) {
                    isTargetHome = true;
                }

                // Add bounce transition and play lord-icon
                const lordIcon = item.querySelector('lord-icon');
                if (lordIcon && lordIcon.play) {
                    lordIcon.play();
                }
                item.style.transform = "scale(0.9)";
                setTimeout(() => {
                    item.style.transform = "scale(1)";
                }, 150);

                const performNav = () => {
                    navItems.forEach(nav => nav.classList.remove('active'));
                    item.classList.add('active');

                    if (href && switchView(href)) {
                        return;
                    }

                    let targetViewId = '';
                    if (index === 0) targetViewId = 'view-home';
                    else if (index === 1) targetViewId = 'view-sub';
                    else if (index === 3) targetViewId = 'view-utils';
                    else if (index === 4) targetViewId = 'view-config';

                    const targetView = document.getElementById(targetViewId);
                    if (targetView) {

                        viewLayers.forEach(view => {
                            view.classList.remove('active');
                            view.style.display = 'none';
                        });

                        targetView.classList.add('active');
                        targetView.style.display = '';

                        // Clean up dynamic frames to release memory (Disabled to prevent visual flashes and re-sync cycles on reopen)
                        // document.querySelectorAll('.view-layer iframe').forEach(iframe => {
                        //     iframe.srcdoc = '';
                        // });

                        const mainScrollerEl = document.getElementById('main-scroller');
                        if (typeof lenis !== 'undefined' && lenis) {
                            lenis.scrollTo(0, { immediate: true });
                        } else if (mainScrollerEl) {
                            mainScrollerEl.scrollTop = 0;
                        }

                        const reveals = targetView.querySelectorAll('.reveal');
                        reveals.forEach(rev => {
                            rev.classList.remove('exit-active');
                            rev.classList.remove('active');
                            void rev.offsetWidth;
                            rev.classList.add('active');
                        });
                    }

                    const lordIconAfter = item.querySelector('lord-icon');
                    if (lordIconAfter) {
                        lordIconAfter.click();
                    }
                };

                setTimeout(() => {
                    if (isCurrentlyHome && !isTargetHome) {
                        animateOutHome(performNav);
                    } else {
                        performNav();
                    }
                }, 400);
            });
        });

        document.querySelectorAll('.modal-btn, .modal-sub-btn').forEach(btn => {
            btn.addEventListener('click', function (e) {
                const href = this.getAttribute('data-href');
                if (!href) return;

                e.preventDefault();

                this.classList.add('clicked');

                if (navigator.vibrate) {
                    navigator.vibrate(15);
                }

                const performModalNav = () => {
                    this.classList.remove('clicked');
                    if (!switchView(href)) {
                        window.location.href = href;
                    }
                };

                const homeView = document.getElementById('view-home');
                if (homeView && homeView.classList.contains('active')) {
                    animateOutHome(performModalNav);
                } else {
                    setTimeout(performModalNav, 220);
                }
            });
        });

        document.querySelectorAll('.panel-row').forEach(row => {
            const href = row.getAttribute('href');
            if (href) {
                row.addEventListener('click', function (e) {
                    e.preventDefault();
                    this.classList.add('clicked');
                    if (navigator.vibrate) {
                        navigator.vibrate(10);
                    }

                    const performRowNav = () => {
                        this.classList.remove('clicked');
                        if (!switchView(href)) {
                            if (href.startsWith('#')) {
                                const target = document.querySelector(href);
                                if (target) target.scrollIntoView({ behavior: 'smooth' });
                            } else {
                                window.location.href = href;
                            }
                        }
                    };

                    const homeView = document.getElementById('view-home');
                    if (homeView && homeView.classList.contains('active')) {
                        animateOutHome(performRowNav);
                    } else {
                        setTimeout(performRowNav, 200);
                    }
                });
            }
        });

        document.querySelectorAll('.feature-item').forEach(item => {
            let activeTimer = null;

            const activate = () => {
                if (activeTimer) {
                    clearTimeout(activeTimer);
                }
                item.classList.add('pill-hovered');
                activeTimer = setTimeout(() => {
                    item.classList.remove('pill-hovered');
                    activeTimer = null;
                }, 2000);
            };

            const deactivate = () => {
                if (activeTimer) {
                    clearTimeout(activeTimer);
                    activeTimer = null;
                }
                item.classList.remove('pill-hovered');
            };

            item.addEventListener('mouseenter', activate);
            item.addEventListener('touchstart', activate, { passive: true });
            item.addEventListener('mouseleave', deactivate);
            item.addEventListener('touchend', deactivate, { passive: true });
        });

        // Global PWA Install Prompt Handler
        window.deferredPrompt = null;
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            window.deferredPrompt = e;

            // Notify active iframe if available
            try {
                const qrIframe = document.getElementById('qr-creator-frame');
                if (qrIframe && qrIframe.contentWindow && typeof qrIframe.contentWindow.showPwaInstallButton === 'function') {
                    qrIframe.contentWindow.showPwaInstallButton();
                }
            } catch (err) { }
        });

        window.installPWA = async function () {
            if (window.deferredPrompt) {
                window.deferredPrompt.prompt();
                const { outcome } = await window.deferredPrompt.userChoice;
                window.deferredPrompt = null;

                // Hide any local install buttons in parent
                const installBtn = document.getElementById('pwaInstallBtn');
                if (installBtn) installBtn.style.display = 'none';

                // Hide inside iframe if visible
                try {
                    const qrIframe = document.getElementById('qr-creator-frame');
                    if (qrIframe && qrIframe.contentWindow) {
                        const localBtn = qrIframe.contentWindow.document.getElementById('pwaInstallBtn');
                        if (localBtn) localBtn.style.display = 'none';
                    }
                } catch (err) { }
            } else {
                const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                    window.matchMedia('(display-mode: fullscreen)').matches ||
                    window.matchMedia('(display-mode: minimal-ui)').matches ||
                    window.navigator.standalone === true;

                let isAlreadyInstalled = false;
                try {
                    if (navigator.getInstalledRelatedApps) {
                        const relatedApps = await navigator.getInstalledRelatedApps();
                        isAlreadyInstalled = relatedApps.length > 0;
                    }
                } catch (e) { }

                // Create animations if missing
                if (!document.getElementById('pwa-exit-style')) {
                    const s = document.createElement('style');
                    s.id = 'pwa-exit-style';
                    s.innerHTML = `
                        @keyframes pwaFadeOut { from { opacity: 1; transform: translate(-50%, 0); } to { opacity: 0; transform: translate(-50%, 20px); } }
                        @keyframes pwaFadeIn { from { opacity: 0; transform: translate(-50%, 20px); } to { opacity: 1; transform: translate(-50%, 0); } }
                    `;
                    document.head.appendChild(s);
                }

                const statusMsg = document.createElement('div');
                statusMsg.id = "pwa-status-toast";
                statusMsg.style.cssText = "position:fixed; bottom:30px; left:50%; transform:translateX(-50%); background:rgba(15, 23, 42, 0.95); backdrop-filter:blur(10px); border:1px solid rgba(255,255,255,0.1); color:white; padding:16px 24px; border-radius:16px; font-weight:600; z-index:2147483647; animation: pwaFadeIn 0.4s cubic-bezier(0.2, 0, 0, 1) forwards; box-shadow: 0 20px 40px rgba(0,0,0,0.5); display:flex; align-items:center; gap:14px; min-width:340px; pointer-events: none;";

                if (isStandalone || isAlreadyInstalled) {
                    statusMsg.innerHTML = `<span class="material-symbols-outlined" style="color:#10b981; font-size:24px;">check_circle</span> <div style="display:flex; flex-direction:column; gap:2px;"><span style="font-size:11px; opacity:0.6; text-transform:uppercase; letter-spacing:1.5px; font-family: 'Space Grotesk', sans-serif;">Suite Status</span><span style="font-size:14px; font-family: 'Inter', sans-serif;">Already Installed & Active on this System</span></div>`;
                } else {
                    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                    if (isiOS) {
                        statusMsg.innerHTML = `<span class="material-symbols-outlined" style="color:#3b82f6; font-size:24px;">info</span> <div style="display:flex; flex-direction:column; gap:2px;"><span style="font-size:11px; opacity:0.6; text-transform:uppercase; letter-spacing:1.5px; font-family: 'Space Grotesk', sans-serif;">iOS Installation</span><span style="font-size:14px; font-family: 'Inter', sans-serif;">Tap Share button and select 'Add to Home Screen'.</span></div>`;
                    } else {
                        statusMsg.innerHTML = `<span class="material-symbols-outlined" style="color:#3b82f6; font-size:24px;">info</span> <div style="display:flex; flex-direction:column; gap:2px;"><span style="font-size:11px; opacity:0.6; text-transform:uppercase; letter-spacing:1.5px; font-family: 'Space Grotesk', sans-serif;">Connectivity Protocol</span><span style="font-size:14px; font-family: 'Inter', sans-serif;">Use browser settings menu to install this PWA.</span></div>`;
                    }
                }

                const existing = document.getElementById('pwa-status-toast');
                if (existing) existing.remove();

                document.body.appendChild(statusMsg);
                setTimeout(() => {
                    statusMsg.style.animation = "pwaFadeOut 0.4s forwards";
                    setTimeout(() => statusMsg.remove(), 400);
                }, 4500);
            }
        };

        // Register Service Worker
        if ('serviceWorker' in navigator) {
            window.addEventListener('load', () => {
                navigator.serviceWorker.register('sw-mobile.js');
            });
        }

        // Setup capturing click listener on the parent document for its own bottom nav items
        document.addEventListener('click', (e) => {
            const navItem = e.target.closest('.bottom-nav .nav-item');
            if (navItem && window.SuiteSounds) {
                window.SuiteSounds.play('BOTTOM_NAV');
            }
        }, { capture: true });

        window.syncActiveFontToIframe = function (iframe) {
            try {
                // If it is the why-upgrade iframe, bypass font synchronization to keep its design fonts independent of system settings
                if (iframe && iframe.id === 'why-upgrade-frame') return;

                const win = iframe.contentWindow;
                const doc = iframe.contentDocument || win.document;
                if (!doc || !doc.body || win.location.href === 'about:blank') return;

                const activeMode = parseInt(localStorage.getItem('active_layer_mode') || '1');

                if (win && typeof win.syncFontMode === 'function') {
                    try {
                        win.syncFontMode(activeMode);
                    } catch (e) {
                        console.warn("Error running local syncFontMode inside iframe:", e);
                    }
                }


                doc.body.classList.remove('font-mode-1', 'font-mode-2', 'font-mode-3', 'font-mode-4', 'font-mode-5', 'font-mode-6', 'font-mode-7', 'font-mode-8');
                doc.body.classList.add(`font-mode-${activeMode}`);

                const protocols = [
                    { font: "'Space Grotesk', sans-serif", accent: "#00f2fe" },
                    { font: "'Montserrat', sans-serif", accent: "#3b82f6" },
                    { font: "'Inter', sans-serif", accent: "#6366f1" },
                    { font: "'Lato', sans-serif", accent: "#10b981" },
                    { font: "'Merriweather', serif", accent: "#f59e0b" },
                    { font: "'Lora', serif", accent: "#ec4899" },
                    { font: "'Clash Display', sans-serif", accent: "#f43f5e" },
                    { font: "'Bricolage Grotesque', sans-serif", accent: "#8b5cf6" }
                ];
                const activeProtocol = protocols[activeMode - 1];
                if (activeProtocol) {
                    if (iframe.id === 'settings-frame') {
                        doc.documentElement.style.setProperty('--primary-accent', activeProtocol.accent);
                    }
                    doc.documentElement.style.setProperty('--font-matrix', activeProtocol.font);
                    doc.documentElement.style.setProperty('--font-sub', activeProtocol.font);
                    doc.body.style.setProperty('--font-matrix', activeProtocol.font);
                    doc.body.style.setProperty('--font-sub', activeProtocol.font);
                    doc.body.style.fontFamily = activeProtocol.font;
                }
            } catch (e) {
                // Silence SecurityError as it normally occurs before iframe is fully loaded/initialized, 
                // or if the iframe is a third-party cross-origin frame.
                if (e.name !== 'SecurityError') {
                    console.error("Error syncing active font to iframe:", e);
                }
            }
        };

        window.syncFontMode = function (mode) {
            document.body.classList.remove('font-mode-1', 'font-mode-2', 'font-mode-3', 'font-mode-4', 'font-mode-5', 'font-mode-6', 'font-mode-7', 'font-mode-8');
            document.body.classList.add(`font-mode-${mode}`);

            const protocols = [
                { font: "'Space Grotesk', sans-serif", accent: "#00f2fe" },
                { font: "'Montserrat', sans-serif", accent: "#3b82f6" },
                { font: "'Inter', sans-serif", accent: "#6366f1" },
                { font: "'Lato', sans-serif", accent: "#10b981" },
                { font: "'Merriweather', serif", accent: "#f59e0b" },
                { font: "'Lora', serif", accent: "#ec4899" },
                { font: "'Clash Display', sans-serif", accent: "#f43f5e" },
                { font: "'Bricolage Grotesque', sans-serif", accent: "#8b5cf6" }
            ];
            const activeProtocol = protocols[mode - 1];
            if (activeProtocol) {
                // Do NOT set --primary-accent on parent document to keep default theme color
                document.documentElement.style.setProperty('--font-matrix', activeProtocol.font);
                document.documentElement.style.setProperty('--font-sub', activeProtocol.font);
                document.body.style.setProperty('--font-matrix', activeProtocol.font);
                document.body.style.setProperty('--font-sub', activeProtocol.font);
                document.body.style.fontFamily = activeProtocol.font;
            }

            document.querySelectorAll('iframe').forEach(iframe => {
                window.syncActiveFontToIframe(iframe);
            });
        };

        window.addEventListener('load', () => {
            const mode = parseInt(localStorage.getItem('active_layer_mode') || '1');
            window.syncFontMode(mode);
        });
        window.addEventListener('storage', (e) => {
            if ((e.key === 'active_layer_mode' || e.key === 'mobile_active_layer_mode') && e.newValue) {
                window.syncFontMode(parseInt(e.newValue));
            }
        });
        window.addEventListener('safeStorageChange', (e) => {
            if (e.detail.key === 'active_layer_mode') {
                const val = e.detail.val !== undefined ? e.detail.val : e.detail.newValue;
                window.syncFontMode(parseInt(val));
            }
        });

        /* --- PREMIUM SaaS APPLICATION LOCK MODULE --- */
        (function () {
            // Local encryption key (used when not logged in to make localStorage secure and undecryptable by others)
            const LOCAL_LOCK_KEY = "QR_BLOOM_LOCAL_LOCK_SECURE_SALT_2026";

            // Memory cache of the lock configuration
            let cachedLockConfig = null;

            // Map imported Firebase module functions for this non-module scope dynamically
            const doc = (...args) => window.suiteDoc(...args);
            const getDoc = (...args) => window.suiteGetDoc(...args);
            const updateDoc = (...args) => window.suiteUpdateDoc(...args);
            const deleteField = (...args) => window.suiteDeleteField(...args);

            // Helper to check if Firebase user is logged in
            function getFirebaseUser() {
                return (window.suiteAuth && window.suiteAuth.currentUser) || null;
            }

            // Encrypt helper using CryptoJS.AES
            function secureEncrypt(text, keyString) {
                const key = keyString || LOCAL_LOCK_KEY;
                return CryptoJS.AES.encrypt(text, key).toString();
            }

            // Decrypt helper using CryptoJS.AES
            function secureDecrypt(ciphertext, keyString) {
                try {
                    const key = keyString || LOCAL_LOCK_KEY;
                    const bytes = CryptoJS.AES.decrypt(ciphertext, key);
                    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
                    if (decrypted) {
                        return decrypted;
                    }
                } catch (e) {
                    // Fall through
                }

                // Fallback: Try decrypting with legacy LOCAL_LOCK_KEY
                if (keyString && keyString !== LOCAL_LOCK_KEY) {
                    try {
                        const bytes = CryptoJS.AES.decrypt(ciphertext, LOCAL_LOCK_KEY);
                        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
                        if (decrypted) {
                            return decrypted;
                        }
                    } catch (e) {
                        return null;
                    }
                }
                return null;
            }

            // Load config (from Firebase if logged in, otherwise from localStorage)
            async function getLockConfig() {
                const user = getFirebaseUser();
                if (user) {
                    try {
                        const userDoc = await getDoc(doc(window.suiteDb, "users", user.uid));
                        if (userDoc.exists()) {
                            const data = userDoc.data();
                            const config = (data.settings && data.settings.app_lock_config) || (data.settings && data.settings.mobile && data.settings.mobile.app_lock_config) || data.app_lock_config || null;
                            window._0x83e2.config = config;
                            // Clean up local storage if logged in
                            localStorage.removeItem('app_lock_config');
                            return config;
                        }
                    } catch (e) {
                        console.error("Error loading config from Firebase:", e);
                    }
                }

                // Fallback to localStorage (encrypted)
                const encryptedConfig = localStorage.getItem('app_lock_config');
                if (encryptedConfig) {
                    try {
                        const decryptedStr = secureDecrypt(encryptedConfig, user ? user.uid : null);
                        if (decryptedStr) {
                            const config = JSON.parse(decryptedStr);
                            window._0x83e2.config = config;
                            return config;
                        }
                    } catch (e) {
                        console.error("Error decrypting local config:", e);
                    }
                }
                window._0x83e2.config = null;
                return null;
            }

            // Save config
            async function saveLockConfig(config) {
                window._0x83e2.config = config;
                const user = getFirebaseUser();
                if (user) {
                    try {
                        const userRef = doc(window.suiteDb, "users", user.uid);
                        // Save under settings.app_lock_config
                        await updateDoc(userRef, {
                            "settings.app_lock_config": config,
                            "settings.mobile.app_lock_config": deleteField()
                        });
                        // Remove from local storage
                        localStorage.removeItem('app_lock_config');
                        return true;
                    } catch (e) {
                        console.error("Error saving config to Firebase:", e);
                        return false;
                    }
                } else {
                    // Not logged in -> encrypt and save in local storage
                    try {
                        const encryptedStr = secureEncrypt(JSON.stringify(config));
                        localStorage.setItem('app_lock_config', encryptedStr);
                        return true;
                    } catch (e) {
                        console.error("Error saving local config:", e);
                        return false;
                    }
                }
            }

            // Expose the API to window._0x83e2
            window._0x83e2 = {
                _0x2k8f: false, // isAppSessionUnlocked: once true, it stays true per session
                _0x1b7d: null,  // pendingView
                config: null,
                pendingCallback: null,
                _lockStatePushed: false,
                _0xR3z: function () {
                    if (window.SessionProtocolParent) {
                        window.SessionProtocolParent.hideOverlay();
                    } else {
                        const overlay = document.getElementById('session-pause-overlay');
                        if (overlay) overlay.style.display = 'none';
                        document.body.classList.remove('is-blurred');
                    }
                },
                _0xP1: function () {
                    if (window.SessionProtocolParent) {
                        window.SessionProtocolParent.showOverlay();
                    } else {
                        const overlay = document.getElementById('session-pause-overlay');
                        if (overlay) overlay.style.display = 'flex';
                    }
                },

                init: async function () {
                    await getLockConfig();

                    // Check URL path or hash for shortcut deep linking
                    // Check URL path or hash for shortcut deep linking
                    let savedView = 'landing';
                    const originalPath = window.location.pathname;
                    let cleanPathOriginal = originalPath;
                    if (cleanPathOriginal.endsWith('index.html')) {
                        cleanPathOriginal = cleanPathOriginal.slice(0, -10);
                    }
                    if (cleanPathOriginal !== '/' && cleanPathOriginal.endsWith('/')) {
                        cleanPathOriginal = cleanPathOriginal.slice(0, -1);
                    }

                    // Intercept Dynamic QR Code redirection route: /d/d_xxxxxx
                    if (cleanPathOriginal.toLowerCase().startsWith('/d/')) {
                        const dynamicId = cleanPathOriginal.substring(3);
                        if (dynamicId) {
                            // Show premium styled loader overlay
                            const overlay = document.createElement('div');
                            overlay.style.cssText = 'position:fixed; top:0; left:0; width:100%; height:100%; background:#0f172a; color:white; font-family:sans-serif; display:flex; flex-direction:column; align-items:center; justify-content:center; z-index:2147483647;';
                            overlay.innerHTML = `
                                <div style="border:4px solid rgba(255,255,255,0.1); border-left-color:#a855f7; border-radius:50%; width:40px; height:40px; animation:spin 1s linear infinite; margin-bottom:16px;"></div>
                                <h3 style="margin:0 0 8px 0; font-weight:600; letter-spacing:0.5px;">REDIRECTING</h3>
                                <p style="margin:0; font-size:12px; color:#94a3b8; text-transform:uppercase; letter-spacing:1px;">Resolving destination reticle...</p>
                                <style>@keyframes spin { to { transform: rotate(360deg); } }</style>
                            `;
                            document.body.appendChild(overlay);

                            try {
                                if (window.suiteDb && window.suiteCollectionGroup && window.suiteQuery && window.suiteWhere && window.suiteGetDocs) {
                                    const q = window.suiteQuery(
                                        window.suiteCollectionGroup(window.suiteDb, 'dynamic_qrs'),
                                        window.suiteWhere('id', '==', dynamicId),
                                        window.suiteLimit(1)
                                    );
                                    const querySnapshot = await window.suiteGetDocs(q);
                                    if (!querySnapshot.empty) {
                                        const dynDoc = querySnapshot.docs[0];
                                        const dynData = dynDoc.data();
                                        let destination = dynData.destinationData || dynData.data;
                                        if (destination) {
                                            destination = destination.trim();

                                            // Perform background telemetry tracking
                                            try {
                                                const docRef = dynDoc.ref;
                                                const currentScansCount = Number(dynData.scansCount || dynData.scanCount || dynData.scans || dynData.clicks || 0);

                                                // Determine unique scan (using in-memory Set)
                                                let isUnique = false;
                                                window._qrbloom_scanned_dyn_qrs = window._qrbloom_scanned_dyn_qrs || new Set();
                                                if (!window._qrbloom_scanned_dyn_qrs.has(dynamicId)) {
                                                    window._qrbloom_scanned_dyn_qrs.add(dynamicId);
                                                    try { localStorage.removeItem('qrbloom_scanned_dyn_qrs'); } catch(e) {}
                                                    isUnique = true;
                                                }
                                                const currentUniqueScans = Number(dynData.uniqueScansCount || dynData.uniqueScans || Math.ceil(currentScansCount * 0.8));

                                                // Cities stats simulation
                                                const citiesList = ['Mumbai', 'Delhi', 'Bangalore', 'Kolkata', 'Chennai', 'Hyderabad', 'Pune'];
                                                const randomCity = citiesList[Math.floor(Math.random() * citiesList.length)];
                                                const currentCitiesMap = JSON.parse(JSON.stringify(dynData.cities || {}));
                                                currentCitiesMap[randomCity] = Number(currentCitiesMap[randomCity] || 0) + 1;

                                                // OS stats tracking
                                                let os = 'Desktop';
                                                if (/iPad|iPhone|iPod/.test(navigator.userAgent)) os = 'iOS';
                                                else if (/Android/.test(navigator.userAgent)) os = 'Android';
                                                const currentDevicesMap = JSON.parse(JSON.stringify(dynData.devices || {}));
                                                currentDevicesMap[os] = Number(currentDevicesMap[os] || 0) + 1;

                                                // Temporal stats tracking
                                                const hour = new Date().getHours();
                                                let period = 'night';
                                                if (hour >= 6 && hour < 12) period = 'morning';
                                                else if (hour >= 12 && hour < 18) period = 'afternoon';
                                                else if (hour >= 18 && hour < 24) period = 'evening';
                                                const currentTemporalMap = JSON.parse(JSON.stringify(dynData.temporal || {}));
                                                currentTemporalMap[period] = Number(currentTemporalMap[period] || 0) + 1;

                                                if (window.suiteUpdateDoc) {
                                                    await window.suiteUpdateDoc(docRef, {
                                                        scansCount: currentScansCount + 1,
                                                        uniqueScansCount: currentUniqueScans + (isUnique ? 1 : 0),
                                                        cities: currentCitiesMap,
                                                        devices: currentDevicesMap,
                                                        temporal: currentTemporalMap
                                                    });
                                                }
                                            } catch (trackErr) {
                                                console.warn("Dynamic QR tracking update deferred:", trackErr);
                                            }

                                            // Intelligent Web URL vs Plain Text Detection
                                            const isWebUrl = (str) => {
                                                if (!str || typeof str !== 'string') return false;
                                                const s = str.trim();
                                                if (/^https?:\/\//i.test(s)) {
                                                    try {
                                                        const parsed = new URL(s);
                                                        return parsed.hostname.includes('.') || parsed.hostname === 'localhost';
                                                    } catch (e) {
                                                        return false;
                                                    }
                                                }
                                                // Check if valid domain with TLD (e.g. google.com, example.org/page), not plain text like 'dfsd'
                                                if (!/\s/.test(s) && /^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i.test(s)) {
                                                    return true;
                                                }
                                                return false;
                                            };

                                            if (isWebUrl(destination)) {
                                                let targetUrl = destination;
                                                if (!/^https?:\/\//i.test(targetUrl)) {
                                                    targetUrl = 'https://' + targetUrl;
                                                }
                                                window.location.replace(targetUrl);
                                                return;
                                            } else {
                                                // Dynamic QR contains plain text (e.g. "dfsd", note, etc.)
                                                // Never push plain text into the browser URL bar as a host!
                                                // Redirect cleanly to the /dynamic slug to display the dynamic result!
                                                try {
                                                    localStorage.setItem('last_dynamic_scan', JSON.stringify({
                                                        text: destination,
                                                        id: dynamicId,
                                                        title: dynData.name || 'Dynamic QR Code',
                                                        time: Date.now()
                                                    }));
                                                } catch (e) {}
                                                window.location.replace('/dynamic?text=' + encodeURIComponent(destination) + '&id=' + encodeURIComponent(dynamicId));
                                                return;
                                            }
                                        }
                                    }
                                }
                                throw new Error("Destination unresolved");
                            } catch (err) {
                                console.error("Dynamic redirect failed:", err);
                                alert("⚠️ Could not resolve this dynamic QR code target destination.");
                                overlay.remove();
                            }
                        }
                    }

                    const cleanPath = cleanPathOriginal.toLowerCase();

                    const pathMap = {
                        '/qr-generator': 'generator',
                        '/qr-decoder': 'decoder',
                        '/barcode-generator': 'barcode-creator',
                        '/barcode-scanner': 'barcode-decoder',
                        '/analytics': 'analytics',
                        '/subscription': 'subscription',
                        '/about': 'about',
                        '/privacy': 'privacy',
                        '/feedback': 'feedback',
                        '/notification': 'notification',
                        '/guide': 'guide',
                        '/shortcuts': 'shortcuts',
                        '/account': 'login',
                        '/settings': 'settings',
                        '/why-upgrade': 'why-upgrade',
                        '/dynamic': 'dynamic'
                    };

                    if (pathMap[cleanPath]) {
                        savedView = pathMap[cleanPath];
                    } else {
                        const hash = window.location.hash;
                        if (hash) {
                            const cleanHash = hash.replace('#', '').toLowerCase();
                            const validViews = [
                                'generator', 'qr bloom qr code.html',
                                'decoder', 'qr decoder.html',
                                'barcode-decoder', 'barcode decoder mobile.html', 'qr_bloom_barcode_decoder.html',
                                'barcode-creator', 'barcode', 'qr bloom bar code.html', '#create-barcode',
                                'settings', 'setting.html', 'setting', '#settings',
                                'analytics', 'analysis', 'analytics.html', 'payment', '#payment',
                                'subscription', 'plan and upgrade.html', 'subscription-mobile.html', '#pro-tier',
                                'notification', 'notification.html', '#notification',
                                'guide', 'guide.html', '#guide',
                                'login', 'login.html', 'account',
                                'about', 'privacy', 'feedback', 'shortcuts', 'why-upgrade', 'dynamic'
                            ];
                            const viewAliasMap = {
                                'generator': 'generator',
                                'decoder': 'decoder',
                                'barcode-decoder': 'barcode-decoder',
                                'settings': 'settings',
                                'setting': 'settings',
                                'notification': 'notification',
                                'guide': 'guide',
                                'analytics': 'analytics',
                                'subscription': 'subscription',
                                'login': 'login',
                                'about': 'about',
                                'privacy': 'privacy',
                                'feedback': 'feedback',
                                'shortcuts': 'shortcuts',
                                'why-upgrade': 'why-upgrade',
                                'dynamic': 'dynamic',
                                'account': 'login'
                            };
                            const matchedView = viewAliasMap[cleanHash] || (validViews.includes(cleanHash) ? cleanHash : null);
                            if (matchedView) {
                                savedView = matchedView;
                            }
                        }
                    }

                    // Save the active view in safeStorage
                    safeStorage.setItem('current_suite_view', savedView);

                    const isLocked = await this.checkAppLock(savedView);
                    if (!isLocked) {
                        try {
                            if (savedView && savedView !== 'landing' && typeof switchView === 'function') {
                                switchView(savedView, false);
                            }
                        } catch (e) {
                            console.error("Failed to restore saved view on init:", e);
                        }
                    }
                },

                // Initialize lock check on page navigation/load
                checkAppLock: async function (targetView) {
                    const config = await getLockConfig();
                    if (config && config.enabled) {
                        const view = targetView || safeStorage.getItem('current_suite_view') || 'landing';
                        const protectedViews = [
                            'generator', 'qr-creator', 'qr bloom qr code.html',
                            'decoder', 'qr-decoder', 'qr decoder.html',
                            'barcode-decoder', 'barcode decoder mobile.html', 'qr_bloom_barcode_decoder.html',
                            'barcode-creator', 'barcode', 'qr bloom bar code.html', '#create-barcode',
                            'settings', 'setting.html', 'setting', '#settings',
                            'analytics', 'analysis', 'analytics.html', 'payment', '#payment',
                            'subscription', 'plan and upgrade.html', 'subscription-mobile.html', '#pro-tier',
                            'notification', 'notification.html', '#notification',
                            'login', 'login.html'
                        ];
                        const isProtected = protectedViews.includes(view.toLowerCase());

                        if (isProtected && !this._0x2k8f) {
                            this.setLockState(true);
                            this._0x1b7d = view;
                            return true;
                        }
                    }
                    this.setLockState(false);
                    return false;
                },

                setLockState: function (isVisible) {
                    const lockScreen = document.getElementById('app-lock-screen');
                    const mainWrapper = document.getElementById('main-scroller') || document.getElementById('main-app-wrapper');
                    if (!lockScreen) return;

                    // Clear fields
                    document.getElementById('lock-password-input').value = '';
                    document.getElementById('new-lock-password').value = '';
                    if (window.updatePinDisplay) window.updatePinDisplay();
                    document.getElementById('recovery-answer-input').value = '';

                    if (isVisible) {
                        const config = window._0x83e2.config;
                        let targetLen = 6;
                        if (config && config.password) {
                            const user = typeof getFirebaseUser === 'function' ? getFirebaseUser() : null;
                            const decryptedPassword = typeof secureDecrypt === 'function' ? secureDecrypt(config.password, user ? user.uid : null) : null;
                            if (decryptedPassword) targetLen = decryptedPassword.length;
                        }
                        this.targetPinLength = targetLen;

                        const pinDisplay = document.getElementById('pin-display');
                        if (pinDisplay) {
                            pinDisplay.innerHTML = '';
                            for (let i = 0; i < targetLen; i++) {
                                const dot = document.createElement('div');
                                dot.className = 'pin-dot';
                                pinDisplay.appendChild(dot);
                            }
                        }

                        document.getElementById('primary-lock-view').style.display = 'block';
                        document.getElementById('recovery-section').style.display = 'none';
                        document.getElementById('reset-password-section').style.display = 'none';
                        document.getElementById('lock-screen-header').style.display = 'block';
                        lockScreen.style.display = 'flex';
                        lockScreen.style.opacity = '1';
                        const card = lockScreen.querySelector('.saas-premium-card');
                        if (card) card.style.animation = '';
                        if (mainWrapper) mainWrapper.style.filter = 'blur(20px)';
                        document.body.classList.add('app-locked');

                        // Intercept back button specifically for App Lock
                        if (window.history && window.history.pushState) {
                            if (!this._lockStatePushed) {
                                window.history.pushState({ isAppLock: true }, "");
                                this._lockStatePushed = true;
                            }
                        }
                    } else {
                        lockScreen.style.opacity = '0';
                        setTimeout(() => {
                            lockScreen.style.display = 'none';
                            if (mainWrapper) mainWrapper.style.filter = 'none';
                        }, 300);
                        document.body.classList.remove('app-locked');

                        // Clear history state if lock screen is dismissed programmatically
                        if (this._lockStatePushed) {
                            this._lockStatePushed = false;
                            if (window.history.state && window.history.state.isAppLock) {
                                window.history.back();
                            }
                        }
                    }
                },

                // Verify the unlock password
                unlockApp: async function () {
                    const passwordInput = document.getElementById('lock-password-input').value;
                    const config = await getLockConfig();
                    if (config) {
                        const user = getFirebaseUser();
                        const decryptedPassword = secureDecrypt(config.password, user ? user.uid : null);
                        if (decryptedPassword === passwordInput) {
                            this._0x2k8f = true; // Mark as unlocked for this session
                            this.setLockState(false);
                            showToast("Access Granted", false);
                            triggerSound('LOCK_SUCCESS');
                            if (this._0x1b7d) {
                                const targetView = this._0x1b7d;
                                this._0x1b7d = null;
                                setTimeout(() => {
                                    if (typeof switchView === 'function') switchView(targetView);
                                }, 150);
                            }
                        } else {
                            showToast("Incorrect PIN", true);
                            triggerSound('ERROR');
                            document.getElementById('lock-password-input').value = '';
                            if (window.updatePinDisplay) window.updatePinDisplay();
                            if (window.shakeLockCard) window.shakeLockCard();
                        }
                    }
                },

                cancelAppLock: function () {
                    this.setLockState(false);
                    this._0x1b7d = null;
                    if (typeof window.closeSPA === 'function') {
                        setTimeout(() => {
                            window.closeSPA();
                        }, 150);
                    } else {
                        setTimeout(() => {
                            if (typeof switchView === 'function') switchView('landing');
                        }, 150);
                    }
                },

                showRecovery: async function () {
                    const config = await getLockConfig();
                    if (config) {
                        const questionMap = {
                            "1": "What was the name of your first pet?",
                            "2": "In what city were you born?",
                            "3": "What is your mother's maiden name?",
                            "4": "What was the name of your first school?",
                            "5": "What is your favorite book?",
                            "6": "What is the make of your first car?",
                            "7": "What is your father's middle name?",
                            "8": "What is the name of your childhood best friend?",
                            "9": "What was your favorite food as a child?",
                            "10": "What is the name of the street you grew up on?"
                        };
                        const qText = questionMap[config.questionId] || "Security Question";
                        document.getElementById('display-recovery-question').innerText = qText;

                        // Clear PIN field when moving to recovery
                        document.getElementById('lock-password-input').value = '';
                        if (window.updatePinDisplay) window.updatePinDisplay();

                        document.getElementById('primary-lock-view').style.display = 'none';
                        document.getElementById('recovery-section').style.display = 'block';
                    }
                },

                hideRecovery: function () {
                    document.getElementById('recovery-section').style.display = 'none';
                    document.getElementById('primary-lock-view').style.display = 'block';
                    document.getElementById('lock-screen-header').style.display = 'block';
                },

                verifyRecovery: async function () {
                    const answerInput = document.getElementById('recovery-answer-input').value.toLowerCase().trim();
                    const config = await getLockConfig();
                    if (config) {
                        const user = getFirebaseUser();
                        const decryptedAnswer = secureDecrypt(config.answer, user ? user.uid : null);
                        if (decryptedAnswer === answerInput) {
                            document.getElementById('recovery-section').style.display = 'none';
                            document.getElementById('reset-password-section').style.display = 'block';
                            document.getElementById('lock-screen-header').style.display = 'none';
                            triggerSound('LOCK_SUCCESS');
                        } else {
                            showToast("Incorrect Answer", true);
                            triggerSound('ERROR');
                            document.getElementById('recovery-answer-input').value = '';
                            if (window.shakeLockCard) window.shakeLockCard();
                        }
                    }
                },

                resetPassword: async function () {
                    const newPassword = document.getElementById('new-lock-password').value;
                    if (newPassword.length < 4) {
                        showToast("Password must be at least 4 characters.", true);
                        document.getElementById('new-lock-password').value = '';
                        if (window.shakeLockCard) window.shakeLockCard();
                        return;
                    }
                    const config = await getLockConfig();
                    if (config) {
                        const user = getFirebaseUser();
                        config.password = secureEncrypt(newPassword, user ? user.uid : null);
                        await saveLockConfig(config);
                        showToast("Password Reset Successful!", false);
                        triggerSound('LOCK_SUCCESS');
                        document.getElementById('reset-password-section').style.display = 'none';
                        document.getElementById('primary-lock-view').style.display = 'block';
                        this._0x2k8f = true;
                        this.setLockState(false);
                        if (this._0x1b7d) {
                            const targetView = this._0x1b7d;
                            this._0x1b7d = null;
                            setTimeout(() => {
                                if (typeof switchView === 'function') switchView(targetView);
                            }, 150);
                        } else {
                            setTimeout(() => {
                                if (typeof switchView === 'function') switchView('landing');
                            }, 150);
                        }
                    }
                },

                // API for Settings frame to decrypt/view configuration
                getDecryptedConfigForSettings: async function () {
                    const config = await getLockConfig();
                    if (config) {
                        const user = getFirebaseUser();
                        const key = user ? user.uid : null;
                        return {
                            password: secureDecrypt(config.password, key),
                            questionId: config.questionId,
                            answer: secureDecrypt(config.answer, key),
                            enabled: config.enabled
                        };
                    }
                    return null;
                },

                // API for Settings frame to save config
                saveNewLockConfig: async function (newConfig) {
                    const user = getFirebaseUser();
                    const key = user ? user.uid : null;
                    const encryptedConfig = {
                        password: secureEncrypt(newConfig.password, key),
                        questionId: newConfig.questionId,
                        answer: secureEncrypt(newConfig.answer.toLowerCase().trim(), key),
                        enabled: newConfig.enabled
                    };
                    const success = await saveLockConfig(encryptedConfig);
                    if (success) {
                        showToast("App Lock Configuration Synchronized.", false);
                        triggerSound('UPGRADE');
                        // After App Lock set, move user to landing page
                        setTimeout(() => {
                            if (typeof window.closeSPA === 'function') {
                                window.closeSPA();
                            } else {
                                switchView('landing');
                            }
                        }, 1000);
                    }
                    return success;
                },

                removeAppLock: async function () {
                    const user = getFirebaseUser();
                    if (user) {
                        const userRef = doc(window.suiteDb, "users", user.uid);
                        await updateDoc(userRef, {
                            "settings.app_lock_config": deleteField(),
                            "settings.mobile.app_lock_config": deleteField()
                        });
                    }
                    localStorage.removeItem('app_lock_config');
                    cachedLockConfig = null;
                    this.config = null;
                    this._0x2k8f = false;
                    showToast("App Lock Removed", false);
                    setTimeout(() => {
                        if (typeof window.closeSPA === 'function') {
                            window.closeSPA();
                        } else {
                            switchView('landing');
                        }
                    }, 1000);
                },

                requestAuth: function (callback, title = "Security Access") {
                    getLockConfig().then(config => {
                        if (!config || !config.enabled) {
                            if (callback) callback();
                            return;
                        }
                        this.pendingCallback = callback;
                        const authModal = document.getElementById('app-auth-modal');
                        const titleEl = document.getElementById('app-auth-title');
                        if (authModal) {
                            if (titleEl) titleEl.innerText = title;
                            authModal.style.display = 'flex';
                            const card = authModal.querySelector('.saas-premium-card');
                            if (card) card.style.animation = '';
                            const input = document.getElementById('app-auth-input');
                            if (input) {
                                input.value = '';
                                input.focus();
                            }
                        }
                    });
                },

                verifyAuth: async function () {
                    const inputField = document.getElementById('app-auth-input');
                    const input = inputField ? inputField.value : '';
                    const config = await getLockConfig();
                    if (config) {
                        const user = getFirebaseUser();
                        const decryptedPassword = secureDecrypt(config.password, user ? user.uid : null);
                        if (input === decryptedPassword) {
                            if (this.pendingCallback) {
                                this.pendingCallback();
                                this.pendingCallback = null;
                            }
                            this.closeAuthModal();
                            showToast("Access Granted", false);
                            triggerSound('LOCK_SUCCESS');
                        } else {
                            showToast("WRONG PASSWORD", true);
                            triggerSound('ERROR');
                            if (inputField) inputField.value = '';
                            if (window.shakeAuthCard) window.shakeAuthCard();
                        }
                    }
                },

                closeAuthModal: function () {
                    const authModal = document.getElementById('app-auth-modal');
                    if (authModal) authModal.style.display = 'none';
                    this.pendingCallback = null;
                },

                unlockSettingsPrivacy: function () {
                    // For mobile settings page compatibility
                    const frame = document.getElementById('settings-frame');
                    if (frame && frame.contentWindow) {
                        try {
                            frame.contentWindow.unlockPrivacySection();
                        } catch (e) { }
                    }
                }
            };
        })();

        // Map global callbacks
        window.unlockApp = function () { window._0x83e2.unlockApp(); };
        window.cancelAppLock = function () { window._0x83e2.cancelAppLock(); };
        window.showRecovery = function () { window._0x83e2.showRecovery(); };
        window.hideRecovery = function () { window._0x83e2.hideRecovery(); };
        window.verifyRecovery = function () { window._0x83e2.verifyRecovery(); };
        window.resetPassword = function () { window._0x83e2.resetPassword(); };
        window.verifyAuth = function () { window._0x83e2.verifyAuth(); };
        window.closeAuthModal = function () { window._0x83e2.closeAuthModal(); };
        window.openLockHelpFeedback = function () {
            document.getElementById('app-lock-help-overlay').style.display = 'none';
            if (typeof switchView === 'function') {
                switchView('feedback');
                const fbEl = document.getElementById('view-feedback');
                if (fbEl) {
                    fbEl.style.zIndex = '2147483645';
                }
            }
        };

        // Intercept back button specifically to dismiss/cancel the App Lock overlay
        window.addEventListener('popstate', function (event) {
            if (window._0x83e2 && window._0x83e2._lockStatePushed) {
                window._0x83e2._lockStatePushed = false;
                window._0x83e2.cancelAppLock();
            }
        });

        window.addPinDigit = function (digit) {
            const isReset = document.getElementById('reset-password-section').style.display === 'block';
            const input = isReset ? document.getElementById('new-lock-password') : document.getElementById('lock-password-input');
            const maxLen = isReset ? 6 : ((window._0x83e2 && window._0x83e2.targetPinLength) || 6);
            if (input.value.length < maxLen) {
                input.value += digit;
                if (!isReset) window.updatePinDisplay();
                if (!isReset && input.value.length === maxLen) {
                    setTimeout(() => {
                        window._0x83e2.unlockApp();
                    }, 50);
                }
            }
        };
        window.deletePinDigit = function () {
            const isReset = document.getElementById('reset-password-section').style.display === 'block';
            const input = isReset ? document.getElementById('new-lock-password') : document.getElementById('lock-password-input');
            if (input.value.length > 0) {
                input.value = input.value.slice(0, -1);
                if (!isReset) window.updatePinDisplay();
            }
        };

        // Handle physical keyboard input for Lock and Reset
        window.addEventListener('keydown', function (e) {
            const lockScreen = document.getElementById('app-lock-screen');
            if (lockScreen && lockScreen.style.display !== 'none' && lockScreen.style.opacity !== '0') {
                const isRecovery = document.getElementById('recovery-section').style.display === 'block';
                if (isRecovery) return; // allow typing natively in recovery

                const isDigit = /^[0-9]$/.test(e.key);
                if (isDigit) {
                    window.addPinDigit(e.key);
                } else if (e.key === 'Backspace') {
                    window.deletePinDigit();
                } else if (e.key === 'Enter') {
                    const isReset = document.getElementById('reset-password-section').style.display === 'block';
                    if (!isReset && document.getElementById('lock-password-input').value.length >= 4) {
                        window._0x83e2.unlockApp();
                    }
                }
            }
        });

        window.updatePinDisplay = function () {
            const len = document.getElementById('lock-password-input').value.length;
            const dots = document.querySelectorAll('#pin-display .pin-dot');
            dots.forEach((dot, index) => {
                if (index < len) {
                    dot.classList.add('filled');
                } else {
                    dot.classList.remove('filled');
                }
            });
        };

        window.toggleLockPassword = function (inputId, eyeId) {
            const field = document.getElementById(inputId);
            const eye = document.getElementById(eyeId);
            if (field) {
                if (field.type === 'password') {
                    field.type = 'text';
                    if (eye) eye.innerText = 'visibility_off';
                } else {
                    field.type = 'password';
                    if (eye) eye.innerText = 'visibility';
                }
            }
        };

        window.shakeLockCard = function () {
            const card = document.querySelector('#app-lock-screen .saas-premium-card');
            if (card) {
                card.classList.add('saas-shake-error');
                setTimeout(() => card.classList.remove('saas-shake-error'), 800);
            }
        };

        window.shakeAuthCard = function () {
            const card = document.querySelector('#app-auth-modal .saas-premium-card');
            if (card) {
                card.classList.add('saas-shake-error');
                setTimeout(() => card.classList.remove('saas-shake-error'), 800);
            }
        };

        // Global animationend listener to clean up entrance animations on premium cards
        document.addEventListener('animationend', function (e) {
            if (e.animationName === 'premium-slide-up' && e.target.classList.contains('saas-premium-card')) {
                e.target.style.animation = 'none';
            }
        });



        window.commitAppLock = async function () {
            const frame = document.getElementById('settings-frame');
            if (!frame || !frame.contentWindow) {
                showToast("Settings frame not found.", true);
                return;
            }
            const iframeDoc = frame.contentDocument || frame.contentWindow.document;
            if (!iframeDoc) {
                showToast("Settings document not accessible.", true);
                return;
            }

            const passwordEl = iframeDoc.getElementById('global-cipher-field');
            const questionEl = iframeDoc.getElementById('security-question-select');
            const answerEl = iframeDoc.getElementById('security-answer-field');

            if (!passwordEl || !questionEl || !answerEl) {
                showToast("Security fields not found in Settings.", true);
                return;
            }

            const password = passwordEl.value;
            const questionId = questionEl.value;
            const answer = answerEl.value;

            // Check if fields are still dummy values (unchanged)
            const isPasswordUntouched = (password === '••••••••');
            const isAnswerUntouched = (answer === '••••••••');

            const currentConfigDecrypted = await window._0x83e2.getDecryptedConfigForSettings();

            if (!isPasswordUntouched) {
                if (!password || password.length < 4 || password.length > 6 || !/^\d+$/.test(password)) {
                    showToast("Password must be a 4 to 6 digit numeric PIN.", true);
                    return;
                }
            }
            if (!questionId) {
                showToast("Please select a security question.", true);
                return;
            }
            if (!isAnswerUntouched && !answer) {
                showToast("Please provide a security answer.", true);
                return;
            }

            const config = {
                password: isPasswordUntouched ? (currentConfigDecrypted ? currentConfigDecrypted.password : '') : password,
                questionId: questionId,
                answer: isAnswerUntouched ? (currentConfigDecrypted ? currentConfigDecrypted.answer : '') : answer.toLowerCase().trim(),
                enabled: true
            };

            const container = iframeDoc.getElementById('settings-privacy-container');
            if (container && container.classList.contains('privacy-restricted')) {
                showToast("Unlock security settings before committing.", true);
                return;
            }

            window.startSecurityConfirmation(config);
        };

        let pendingLockConfig = null;
        window.startSecurityConfirmation = function (config) {
            pendingLockConfig = config;
            const overlay = document.getElementById('security-confirm-overlay');
            if (overlay) {
                overlay.style.display = 'flex';
                window.nextSecurityLayer(1);
            }
        };
        window.nextSecurityLayer = function (step) {
            for (let i = 1; i <= 3; i++) {
                const layer = document.getElementById(`confirm-layer-${i}`);
                if (layer) layer.classList.remove('active');
            }
            const target = document.getElementById(`confirm-layer-${step}`);
            if (target) target.classList.add('active');
        };
        window.closeSecurityConfirmation = function () {
            const overlay = document.getElementById('security-confirm-overlay');
            if (overlay) overlay.style.display = 'none';
        };
        window.finalizeAppLock = async function () {
            if (pendingLockConfig) {
                await window._0x83e2.saveNewLockConfig(pendingLockConfig);
                window.closeSecurityConfirmation();
            }
        };

        window.addEventListener('load', () => {
            if (window._0x83e2) {
                window._0x83e2.init();
            }
        });

        // Dynamic routing when hash changes while the app is active
        window.addEventListener('hashchange', () => {
            const hash = window.location.hash;
            if (hash) {
                const cleanHash = hash.replace('#', '').toLowerCase();
                const viewMap = {
                    'generator': 'generator',
                    'qr-creator': 'generator',
                    'decoder': 'decoder',
                    'qr-decoder': 'decoder',
                    'barcode-decoder': 'barcode-decoder',
                    'settings': 'settings',
                    'setting': 'settings',
                    'notification': 'notification',
                    'analytics': 'analytics',
                    'subscription': 'subscription'
                };
                const targetView = viewMap[cleanHash];
                if (targetView && typeof switchView === 'function') {
                    switchView(targetView);
                }
            }
        });

        // Launch Queue handling for modern PWAs focusing existing window
        if ('launchQueue' in window) {
            window.launchQueue.setConsumer((launchParams) => {
                if (!launchParams.targetURL) return;
                try {
                    const url = new URL(launchParams.targetURL);
                    const hash = url.hash;
                    if (hash) {
                        const cleanHash = hash.replace('#', '').toLowerCase();
                        const viewMap = {
                            'generator': 'generator',
                            'qr-creator': 'generator',
                            'decoder': 'decoder',
                            'qr-decoder': 'decoder',
                            'barcode-decoder': 'barcode-decoder',
                            'settings': 'settings',
                            'setting': 'settings',
                            'notification': 'notification',
                            'analytics': 'analytics',
                            'subscription': 'subscription'
                        };
                        const targetView = viewMap[cleanHash];
                        if (targetView && typeof switchView === 'function') {
                            switchView(targetView);
                        }
                    }
                } catch (e) {
                    console.error("Launch Queue parsing failed:", e);
                }
            });
        }

        lucide.createIcons();

        // Expose globals for ESM compatibility with iframes
        window.switchView = switchView;
        window.showToast = showToast;
        window.animateOutHome = animateOutHome;
        window.initAnimations = initAnimations;
        window._attachPrivacyDrag = _attachPrivacyDrag;
        window.initPrivacyToast = initPrivacyToast;
        window.syncNavAnim = syncNavAnim;
        window.lenis = lenis;
        window.scroller = scroller;